<template>
  <div class="vld-parent">

    <v-dialog v-if="dateDialog" persistent v-model="dateDialog" max-width="290">
      <v-card>
        <v-card-title class="text-h5">Item Failed to Approve</v-card-title>
        <v-card-text>wrong date was picked</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="white-darken-1" variant="text" @click="dateDialog = false">Close</v-btn>
          <!-- <v-btn color="green darken-1" text @click="dateDialog = false">Change Now</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="errorDialog" v-model="errorDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Error</span>
        </v-card-title>
        <v-card-text v-if="errorDialogText" />
        <v-card-actions>
          <v-spacer />
          <v-btn color="green-darken-1" variant="text" @click="errorDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active="isLoading" :can-cancel="false" :is-full-page="true" />
    <v-snackbar v-model="snackbar" :location="'top'" :multi-line="false" :timeout="6000" :vertical="false">
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">Close</v-btn>         
      </template>
    </v-snackbar>

    <v-layout v-if="approveAlert" justify-center>
      <v-col cols="12" sm="5" md="5">
        <div class="alert_text">
          <v-alert v-model="approveAlert" closable type="success">
            {{ alertText }}
          </v-alert>
        </div>
      </v-col>
    </v-layout>

    <v-layout v-if="declineAlert" justify-center>
      <v-col cols="12" sm="5" md="5">
        <div class="alert_text">
          <v-alert v-model="declineAlert" closable type="info" icon="do_not_disturb" color="#ac00b6">
            {{ alertText }}
          </v-alert>
        </div>
      </v-col>
    </v-layout>

    <v-layout v-if="errorAlert" justify-center>
      <v-col cols="12" sm="5" md="5">
        <div class="alert_text">
          <v-alert v-model="errorAlert" closable type="error" icon="disabled_by_default" color="#cf0041">
            {{ alertText }}
          </v-alert>
        </div>
      </v-col>
    </v-layout>

    <transition name="router-anim" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutDown">
      <v-sheet>
        <v-card-title>
          <v-row class="pa-4">

            <v-icon v-bind:class="[
              { 'pt-4 text-green': id == 'approved' },
              { 'pt-4 text-red': id == 'failed' },
              { 'pt-4 text-blue': id == 'dashboard' },
              { 'pt-4 text-orange': id == 'pending' },
              { 'pt-4 text-purple': id == 'declined' },
              { 'pt-4 text-red': id == 'Quotes' },
                ]">{{ id == "declined" ? "mdi-cancel" : id == "approved" ? "mdi-check-circle-outline" : id == "Quotes"
                 ? "mdi-currency-usd" : id == "failed" ? "mdi-check-circle-outline" : "mdi-timelapse"
                }}
            </v-icon>

            <h2 v-bind:class="[
                  { 'text-green': id == 'approved' },
                  { 'text-red': id == 'failed' },
                  { 'text-blue': id == 'dashboard' },
                  { 'text-orange': id == 'pending' },
                  { 'text-purple': id == 'declined' },
                  { 'text-red': id == 'Quotes' },
                ]">
              {{ capitalized(id) }}
            </h2>

            <span v-if="isFiltered" class="text-grey pt-3" >
              &nbsp; | Filtered Results
            </span>
            <span v-if="id == 'Quotes'">
              <v-switch  class="custom_switch" 
                v-model="showExpiredQuotes"
                :model-value="showExpiredQuotes?true:false"
                color="success" label="Show expired quotes"
                @update:model-value=getDataFromServer() />


            </span>
            <span v-if="id == 'Quotes'">
              <v-switch 
               @update:model-value=getDataFromServer() 
              class="custom_switch" 
              v-model="showDeletedQuotes"
              :model-value="showDeletedQuotes?true:false"
              color="success" label="Show deleted quotes" />
            </span>
            <div class="d-flex align-center justify-end"
              style="right: 0px; position: absolute; margin-right: 10px; width: 60%; gap: 24px;">
              <v-text-field
                v-model="search"
                placeholder="Search"
                append-inner-icon="mdi-magnify"
                variant="underlined"
                density="compact"
                hide-details
                clearable
              />
              <download-excel :hidden="bookings.length == 0"
                :data="bookings" type="csv" :name="`${id}.xls`" :fields="getExportFields()">
                <v-btn variant="outlined" color="green-darken-2">
                  spreadsheet
                  <v-icon>mdi-arrow-down</v-icon>
                </v-btn>
              </download-excel>
            </div>

          </v-row>

        </v-card-title>

       
 
        <div style="z-index: 0; " >   
        <v-data-table-server
          v-model:sort-by="sortBy"
          v-model:page="pagination.page"
          v-model:items-per-page="pagination.rowsPerPage"
          :headers="getHeaders()"
          :items="displayedBookings"
          :items-length="totalBookings"
          class="elevation-1"
          ref="datatable"
          :class="getTableClass()"
          @update:options="getDataFromServer"
          >
          <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort  }" >
            <tr >
              <td v-for="column in columns" :key="column.key" class="pa-2 text-center">
                <v-text-field class="search-field text-center"  v-bind:placeholder="column.title" :class="'ta-grid-'+column.value"
                  v-if="column.title !== 'Actions' && column.title !== 'Sig' " 
                  v-bind:modelValue="column.searchedText"
                  @update:modelValue="searhResult($event,column.searchedText, column.value)" 
                  variant="underlined"
                  style="font-size: small;" 
                />
                 
                <v-text-field class="search-field text-center" v-bind:placeholder="column.title"
                  v-else-if="column.title == 'Error' "
                  v-bind:modelValue="column.searchedText"
                  @update:modelValue="searhResult($event,column.searchedText, column.value)" 
                  variant="underlined"
                  style="font-size: small;width:120px !important;"
                />

                <v-btn
                  v-else-if="column.title == 'Actions' && hasColumnFilters"
                  size="small"
                  color="primary"
                  @click="applyColumnFilters"
                >Apply Filters</v-btn>

              </td>
              
            </tr>   
            <tr>
              <template v-for="column in columns" :key="column.key" >
                <td class="pa-0 text-center"  v-if="column.key == 'BookingTimestamp'" style="width:150px;">
                  <template v-if="isSorted(column)">
                    <v-icon :icon="getSortIcon(column)"></v-icon>
                  </template>
                  <span class="cursor-pointer pa-0 " @click="() => toggleSort(column)" style="font-size: 12px !important;">
                      {{column.title }}
                  </span>                 
                </td>                  
   
                <td class="pa-0 text-center"  v-else-if="column.key == 'Error'" style="width:100px !important; max-width: 100px !important;">
                  <template v-if="isSorted(column)">
                    <v-icon :icon="getSortIcon(column)"></v-icon>
                  </template>
                  <span class="cursor-pointer pa-0 " @click="() => toggleSort(column)" style="font-size: 12px !important;width:100px  !important; max-width: 100px !important;">
                   {{column.title }}
                  </span>                
                </td> 

                <td class="pa-0 text-center"  v-else-if="column.key == 'CustomerDescription'" style="width:150px;">
                  <template v-if="isSorted(column)">
                    <v-icon :icon="getSortIcon(column)"></v-icon>
                  </template>
                 <span class="cursor-pointer pa-0 " @click="() => toggleSort(column)" style="font-size: 12px !important;">
                   {{column.title }}
                 </span>                 
                </td> 

                <td class="pa-0 text-center"  v-else-if="column.key == 'ApproveTimestamp'" style="width:150px;">
                  <template v-if="isSorted(column)">
                    <v-icon :icon="getSortIcon(column)"></v-icon>
                  </template>
                 <span class="cursor-pointer pa-0 " @click="() => toggleSort(column)" style="font-size: 12px !important;">
                   {{column.title }}
                  </span>                 
                </td>  
                
                <td class="pa-0"  v-else-if="column.key == 'Actions' &&  ( id == 'failed'|| id == 'Quotes' )" style="width:8%;">
                  <template v-if="isSorted(column)">
                    <v-icon :icon="getSortIcon(column)"></v-icon>
                  </template>
                  <span class="cursor-pointer pa-0" @click="() => toggleSort(column)" >{{column.title }}</span>
                  
                </td>
                
                <td class="pa-0"  v-else-if="column.key == 'Actions' &&  (id == 'pending')" style="width:150px;">
                  <template v-if="isSorted(column)">
                    <v-icon :icon="getSortIcon(column)"></v-icon>
                  </template>
                  <span class="cursor-pointer pa-0" @click="() => toggleSort(column)" >{{column.title }}</span>
                  
                </td>  
                
                <td class="pa-0 text-center"  v-else-if="column.key == 'Signature' || column.key=='TransactionType'" style="width:50px;">
                  <template v-if="isSorted(column)">
                    <v-icon :icon="getSortIcon(column)"></v-icon>
                  </template>
                  <span class="cursor-pointer pa-0 " @click="() => toggleSort(column)" >{{column.title }}</span>
                  
                </td>  
                
                <td class="pa-0 text-center"  v-else-if="column.key == 'Signature' || column.key=='TransactionType'" style="width:50px;">
                  <template v-if="isSorted(column)">
                    <v-icon :icon="getSortIcon(column)"></v-icon>
                  </template>
                  <span class="cursor-pointer pa-0 " @click="() => toggleSort(column)" >{{
                    column.title }}</span>
                  
                </td>  

                <td class="pa-0 text-center"  v-else style="width:80px;" >
                  <template v-if="isSorted(column)">
                    <v-icon :icon="getSortIcon(column)"></v-icon>
                  </template>

                 <span class="cursor-pointer pa-0" @click="() => toggleSort(column)" style="font-size: 12px !important;">
                    {{column.title }}
                  </span>
                </td>
              </template>
            </tr>

          </template>

          <template v-slot:item="{ item }" >
           
            
              <tr :class="itemRowBackground(item)">
                <td class="text-center hidden-xs pa-0" >
                  {{ item.Location }}
                </td>
                <td class="text-center pa-0" style="padding: 0 !important;">
                  {{ bookingTimestampDateTime(item.BookingTimestamp) }}
                </td>
                <td v-if="(id == 'failed' || id == 'pending' || id == 'Quotes')" class="text-center  pa-0">
                  {{ item.OriginalBookingNumber }}
                </td>
                <td class="text-center hidden-xs pl-1 pr-1">
                  {{ item.CustomerId }}
                </td>
                <td class="text-center pa-0">
                  {{ item.CustomerDescription }}
                </td>
                <td v-if="!item.isSelected" class="text-center hidden-xs pa-0">
                  {{  formatPrice(item.CreditAvailable) }}
                </td>
                <td v-if="!item.isSelected" class="text-center hidden-xs pa-0">
                  {{ formatPrice(item.TotalPrice) }}
                </td>
                <td v-if="!item.isSelected" class="text-center hidden-xs pa-0">
                  {{ item.TransactionType || "Book" }}
                </td>
                <td v-if="!item.isSelected" class="text-center hidden-xs pa-0">
                  <v-icon v-if="item.Signature && !item.IsByPhone" v-bind:class="[
                    {
                      'pa-0 text-green': item.Signature,
                      'pa-0 text-red': !item.Signature,
                    },
                  ]">mdi-checkbox-marked</v-icon>
                  <v-icon v-if="item.IsByPhone" v-bind:class="[
                    {
                      'pa-0 text-green': item.IsByPhone,
                      'pa-0 text-red': !item.IsByPhone,
                    },
                  ]">mdi-phone</v-icon>
                </td>
                <td v-if="!item.isSelected" class="pl-1 pr-1 text-center hidden-xs">
                  {{ DateFormate(item.StartDate) }}
                </td>
                <td v-if="!item.isSelected" class="pl-1 pr-1 text-center hidden-xs">
                  {{ DateFormate(item.EndDate) }}
                </td>

                <td v-if="!item.isSelected" class="pa-0 text-center hidden-xs">
                  {{ item.BookingUser }}
                </td>
                <td v-if="id == 'Quotes' && showDeletedQuotes" class="pa-0 text-center">
                  {{ item.DeletedBy }}
                </td>
                <td v-if="id == 'Quotes' && showDeletedQuotes" class="pa-0 text-center">
                  {{ item.DeletedTimeStamp }}
                </td>
                <td v-if="id == 'Quotes' && showExpiredQuotes" class="pa-0 text-center">
                  {{ DateFormate(item.ExpiryDate) }}

                </td>
                <td v-if="!item.isSelected && id == 'declined'" class="pl-1 pr-1 text-center">
                  {{ item.ApproveTimestamp }}
                </td>

                <td v-if="item.isSelected" v-bind:class="getCSSClass(item.isSuccessfull)" :colspan="getColspan(id)">
                  {{ getMessage(item) }}
                </td>
                <td v-if="id == 'approved'" class="pa-0 text-center" style="font-size:small;font-weight: 400">
                  {{ item.BookingNumber }}
                </td>
              
                <td v-if="!item.isSelected && id == 'failed'" class="pa-2 text-left overflow-y:auto" style="width:100px !important; max-width: 100px !important;" >   
                   <div  class="pa-0 text-center">
                      <v-dialog max-width="800">                        
                        <template v-slot:activator="{ props: activatorProps }">
                          <v-btn 
                            size="small"
                            v-bind="activatorProps"
                            color="warning" 
                            elevation="8"                                
                          > View Error 
                            <v-tooltip
                              activator="parent"
                              location="top"
                              > {{ item.Error }}
                            </v-tooltip>
                        
                          </v-btn>
                        </template>
                        <template v-slot:default="{ isActive }">
                          <v-card >
                            <template v-slot:title>
                              Agris Response
                            </template>
                            <template v-slot:subtitle>
                              <div class="d-flex justify-space-between flex-row">
                                <div class="text">
                                  <span>
                                    <p> <strong>Date :</strong>  {{ bookingTimestampDateTime(item.BookingTimestamp) }} </p>
                                    <p> <strong>Location :</strong> {{ item.Location }}</p> 
                                    <p> <strong>Pending# :</strong> {{ item.OriginalBookingNumber }} </p> 
                                  </span>
                                  <!-- <v-text>
                                    <p> <strong>Date :</strong>  {{ bookingTimestampDateTime(item.BookingTimestamp) }} </p>
                                    <p> <strong>Location :</strong> {{ item.Location }}</p> 
                                    <p> <strong>Pending# :</strong> {{ item.OriginalBookingNumber }} </p> 
                                  </v-text> -->
                                </div>
                                <div class="text">
                                  <span>
                                    <p> <strong>Customer Id :</strong>  {{ item.CustomerId }} </p>
                                    <p> <strong>Customer Description :</strong>  {{ item.CustomerDescription }}</p> 
                                    <p> <strong>Type :</strong>  {{ item.TransactionType || "Book" }} </p> 
                                  </span>
                                  <!-- <v-text>
                                    <p> <strong>Customer Id :</strong>  {{ item.CustomerId }} </p>
                                    <p> <strong>Customer Description :</strong>  {{ item.CustomerDescription }}</p> 
                                    <p> <strong>Type :</strong>  {{ item.TransactionType || "Book" }} </p> 
                                  </v-text> -->
                                </div>
                                <div class="text">
                                  <span>
                                    <p> <strong>User :</strong>{{ item.BookingUser }} </p>                                        
                                  </span>
                                  <!-- <v-text>
                                    <p> <strong>User :</strong>{{ item.BookingUser }} </p>                                        
                                  </v-text> -->
                                </div>
                              </div>
                            </template>
                            <template v-slot:text>
                              <v-spacer></v-spacer>
                              <code>
                                <small><b>{{ item.Error }}</b></small>
                              </code>
                              
                            </template>
                            <v-card-actions>
                              <v-spacer></v-spacer>                              
                              <v-btn
                                text="close"
                                variant="outlined"
                                @click="isActive.value = false"
                              ></v-btn>
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>
                   </div>               
                 </td> 

                <td v-if="!item.isSelected && (
                  id == 'pending'
                  || id == 'failed'
                  || id == 'approved'
                  || id == 'declined'
                  || id == 'Quotes')
                  " class="justify-center px-0 w-10">

                  <!-- <v-icon v-if="(! item.Error && ! item.PrintFailedError)" color="info" class="ml-0 pl-0 mr-0 pr-0 font_small" @click="editItem( item)">info</v-icon> -->

                  <!-- <v-icon
                    v-if="((IsProUser == true)
                      && (item.IsPendingFileFlob)
                      && (item.PrintFailedError == null || item.PrintFailedError == '')
                      && (item.OriginalBookingNumber !== null && item.OriginalBookingNumber != 'duplicate')
                      && pendingAgreementSettingStatus == true
                      && (id == 'pending'))"
                    color="blue-grey-darken-2"
                  :disabled="!item.IsPendingFileFlob && item.OriginalBookingNumber !== null && item.OriginalBookingNumber != 'duplicate'"
                    class="ml-0 pl-0 mr-0 pr-0 font_large"
                    @click="DownloadItem(item, id)">mdi-file-pdf-box
                  </v-icon> -->



                  <template v-if="((IsProUser == true)
                    && (item.IsPendingFileFlob)
                    && (item.PrintFailedError == null || item.PrintFailedError == '')
                    && (item.OriginalBookingNumber !== null && item.OriginalBookingNumber != 'duplicate')
                    && pendingAgreementSettingStatus == true
                    && (id == 'pending'))">
                    <v-icon class="ml-0 pl-0 mr-0 pr-0 font_large ta-grid-pdf" color="blue-grey-darken-2"
                      @click="DownloadItem(item, id)">
                      mdi-file-pdf-box
                    </v-icon>

                  </template>
                  <template v-if="((IsProUser == true)
                    && (item.IsPendingFileFlob == null || item.IsPendingFileFlob == undefined || item.IsPendingFileFlob == '')
                    // && (item.OriginalBookingNumber == null || item.OriginalBookingNumber == 'duplicate')                     
                    // && (item.PrintFailedError == null || item.PrintFailedError == '')                   
                    // && pendingAgreementSettingStatus == true
                    && (id == 'pending'))
                    ">
                    <v-icon class="ml-0 pl-0 mr-0  pr-0 font_large" color="blue-grey-light">
                      mdi-file-pdf-box
                    </v-icon>
                  </template>

                  <template v-if="((IsProUser == true)
                    && (item.IsApprovedFileFlob == null ||item.IsApprovedFileFlob == undefined || item.IsApprovedFileFlob == '')
                    //&& (item.PrintFailedError == null || item.PrintFailedError == '')
                    //&& (item.BookingNumber !== null)
                    //&& pendingAgreementSettingStatus == true 
                    && (id == 'approved'))">
                    <v-icon class="ml-0 pl-0 mr-0 pb-4 pr-0 font_large" color="blue-grey-light">
                      mdi-file-pdf-box
                    </v-icon>
                  </template>

                  <v-icon v-if="((IsProUser == true)
                    && (item.IsApprovedFileFlob)
                    && (item.PrintFailedError == null || item.PrintFailedError == '')
                    && (item.BookingNumber !== null)
                    && pendingAgreementSettingStatus == true && (id == 'approved'))" color="blue-grey-darken-2"
                    class="ml-0 pl-0 mr-0 pr-0 pb-4 font_larg ta-grid-pdf" @click="DownloadItem(item, id)">mdi-file-pdf-box
                  </v-icon>

                  <v-icon v-if="(id != 'pending' && id != 'approved' && id != 'Quotes')" color="info"
                    class="ml-0 pl-0 mr-0 pr-0 font_large ta-grid-edit" @click="editItem(item, id)">mdi-information
                  </v-icon>

                  <!-- <v-icon v-if="( (id == 'pending' || id == 'approved') && pendingAgreementSettingStatus == false)" color="info" class="ml-0 pl-0 mr-0 pr-0 font_small" @click="editItem( item)">info</v-icon> -->

                  <v-icon v-if="((id == 'pending' )
                    && pendingAgreementSettingStatus == true
                    && item.TransactionType == 'Order')" color="info" class="ml-0 pl-0 mr-0 pr-0 font_large ta-grid-edit"
                    @click="editItem(item, id)">mdi-information
                  </v-icon>

                  <v-icon v-if="((id == 'approved')
                    && pendingAgreementSettingStatus == true
                    && item.TransactionType == 'Order')" color="info" class="ml-0 pb-4 pl-0 mr-0 pr-0 font_large ta-grid-edit"
                    @click="editItem(item, id)">mdi-information
                  </v-icon>

                  <!-- <v-icon v-if="(id == 'approved' && pendingAgreementSettingStatus == false)" color="info" class="ml-0 pl-0 mr-0 pr-0 font_small" @click="editItem( item)">info</v-icon> -->

                  <v-icon v-if="(pendingAgreementSettingStatus == false && (id == 'pending' || id == 'approved'))"
                    color="info" class="ml-0 pl-0 mr-0 pr-0  font_large ta-grid-edit" @click="editItem(item, id)">mdi-information</v-icon>

                  <template
                    v-if="pendingAgreementSettingStatus == true && (id == 'pending') && item.TransactionType != 'Order'">
                    <!-- <v-icon overlap color="info" size="large"
                      v-if="item.PrintFailedError || item.Error || item.IsVoidFailed" class="ml-0 pl-0 mr-0 pr-0 font_large"
                      @click="editItem(item, id)">mdi-information</v-icon> -->
                   
                    <v-badge
                      color="error"
                      dot
                      v-if=" item.PrintFailedError ||  item.Error ||  item.IsVoidFailed"
                      style="position: relative;top: 8px;"
                    >
                    <v-icon  size="large" color="info" class="ml-0 pl-0 mr-0 pr-0 font_large ta-grid-edit" @click="editItem( item,id)">mdi-information</v-icon>
                    </v-badge>

                    <!-- <v-badge overlap icon="mdi-lock" color="error" v-if=" id =='Quotes' &&  items.IsAlert">
                          <template v-slot:badge>
                            <div class="print-error-badge">!</div>
                          </template>
                        <v-icon large color="info" class="ml-0 pl-0 mr-0 pr-0 font_small" @click="editItem( item)">mdi-information</v-icon>
                        </v-badge> -->
                    <v-icon v-else color="info" class="ml-0 pl-0 mr-0 pr-0 font_large ta-grid-edit "
                      @click="editItem(item, id) ">mdi-information</v-icon>
                  </template>
                  <template v-if="id == 'Quotes'">
                    <v-icon v-if="item.IsAlert" size="large" color="warning "
                      class="ml-0 pl-0 mr-0 pr-0 font_large ta-grid-edit"
                      @click="editItem(item, id)">mdi-information</v-icon>
                    <!-- <v-badge overlap icon="mdi-lock" color="error" v-if=" id =='Quotes' &&  items.IsAlert">
                      <template v-slot:badge>
                        <div class="print-error-badge">!</div>
                      </template>
                    <v-icon large color="info" class="ml-0 pl-0 mr-0 pr-0 font_small" @click="editItem( item)">info</v-icon>
                    </v-badge> -->
                    <v-icon v-else color="info" class="ml-0 pl-0 mr-0 pr-0 font_large ta-grid-edit ta-grid-delete"
                      @click="editItem(item, id)">mdi-information</v-icon>
                    <v-icon v-if="showExpiredQuotes && !item.IsDeleted && item.IsExpired" color="error"
                      class="ml-0 pl-0 mr-0 pr-0 font_large" @click="deletequote(item)">mdi-trash-can-outline</v-icon>

                  </template>

                  <template
                    v-if="pendingAgreementSettingStatus == true && id == 'approved' && item.TransactionType != 'Order'">
                    <!-- <v-icon overlap color="info" size="large" v-if="item.PrintFailedError || item.IsVoidFailed"
                      class="print-error-badge ml-0 pl-0 mr-0 pr-0 font_large" @click="editItem(item, id)">
                      mdi-information

                    </v-icon> -->
                    <v-badge dot  color="error" v-if="item.PrintFailedError || item.IsVoidFailed">
                      <!-- <template v-slot:badge>
                        <div class="print-error-badge">!</div>
                      </template> -->
                      <v-icon large color="info" class="ml-0 pl-0 mr-0 pr-0 pt-1 font_large ta-grid-edit"
                        @click="editItem(item, id)">mdi-information</v-icon>
                    </v-badge>

                    <v-icon v-else color="info" class="ml-0 pl-0 pb-4 mr-0 pr-0 font_large ta-grid-edit"
                      @click="editItem(item, id)">mdi-information</v-icon>
                  </template>

                  <span class="padding_top_12" :title="item.TransactionType == 'Order'
                    && isOrderPermission == false
                    ? 'Please set up (INV - Import Orders) security to level 3 or higher in AGRIS.'
                    : ''
                    ">
                    <v-icon v-if="id == 'pending' || id == 'failed'" color="success" class="ml-0 pl-0 mr-0 pr-0 font_large ta-grid-approve"
                      @click="approveBooking(item)" :disabled="item.TransactionType == 'Order'
                        && isOrderPermission == false
                        ">mdi-check-circle-outline</v-icon>
                  </span>

                  <v-icon v-if="(id == 'pending' || id == 'failed') && !item.IsVoidFailed" color="error"
                    class="ml-0 pl-0 mr-0 pr-0 font_large ta-grid-delete" @click="declineBooking(item)">mdi-close-circle-outline</v-icon>
                </td>
              </tr>
           
           
          </template>

         
        </v-data-table-server>
        <br>
        <br>
        <br>

        <v-dialog persistent v-model="detaildialog" max-width="100%" style="z-index: 1000;">
          <form>
            <v-card class="padding_5_20">
              <span v-if="showWarning(editedItem)">
                <v-alert class="pa-1 ml-1 mr-1" :value="true" type="warning">Total Amount Has Exceeded Available
                  Credit.</v-alert>
              </span>

              <div
                v-if="pendingAgreementSettingStatus == true && editedItem.PrintFailedError && editedItem.TransactionType != 'Order' && (id == 'pending' || id == 'approved')"
                class="text-center print-error-message">
                <p>Unable to print the pending
                  <span v-if="editedItem.TransactionType == 'Book'">Booking</span>
                  <span v-if="editedItem.TransactionType == 'Prepay'">Prepay</span> for this transaction
                </p>
                <div>
                  <a href="javascript:;" @click="printtranscation(editedItem, false, false, true)">Try Again</a> &nbsp;
                  &nbsp;
                  <a href="javascript:;"
                    @click="editedItem.showErrorDetails = editedItem.showErrorDetails == true ? false : true">
                    <span v-if="!editedItem.showErrorDetails">Show Details</span>
                    <span v-if="editedItem.showErrorDetails">Hide Details</span>
                  </a>
                </div>
                <p v-if="editedItem.showErrorDetails">
                  <v-icon style="font-size:18px;" class="red--text">info</v-icon> &nbsp;
                  <span style="font-size:12px;">{{ editedItem.PrintFailedError }}</span>
                </p>
              </div>

              <div v-if="pendingAgreementSettingStatus == true && editedItem.Error && id == 'pending'"
                class="text-center print-error-message">
                <p>Unable to generate the pending
                  <span v-if="editedItem.TransactionType == 'Book'">Booking</span>
                  <span v-if="editedItem.TransactionType == 'Prepay'">Prepay</span> for this transaction
                </p>
                <div>
                  <a href="javascript:;" @click="retryBookingOnError(editedItem)">Try Again</a> &nbsp; &nbsp;
                  <a href="javascript:;"
                    @click="editedItem.showErrorDetails = editedItem.showErrorDetails == true ? false : true">
                    <span v-if="!editedItem.showErrorDetails">Show Details</span>
                    <span v-if="editedItem.showErrorDetails">Hide Details</span>
                  </a>
                </div>
                <p v-if="editedItem.showErrorDetails">
                  <v-icon style="font-size:18px;" class="red--text">info</v-icon> &nbsp;
                  <span style="font-size:12px;">{{ editedItem.Error }}</span>
                </p>
              </div>
              <div v-if="pendingAgreementSettingStatus == true && id == 'approved' && editedItem.IsVoidFailed == true"
                class="text-center print-error-message">
                <p>Unable to void the pending
                  <span v-if="editedItem.TransactionType == 'Book'">Booking</span>
                  <span v-if="editedItem.TransactionType == 'Prepay'">Prepay</span> for this transaction. Can you please
                  check Failed page and Retry.
                </p>
                <!-- <div>
                  <a href="javascript:;" @click="retryBookingOnError(editedItem)">Try Again</a> &nbsp; &nbsp;
                  <a href="javascript:;" @click="editedItem.showErrorDetails = editedItem.showErrorDetails == true ? false : true">
                    <span v-if="!editedItem.showErrorDetails">Show Details</span>
                    <span v-if="editedItem.showErrorDetails">Hide Details</span>
                  </a>
                </div>
                <p v-if="editedItem.showErrorDetails">
                  <v-icon style="font-size:18px;" class="red--text">info</v-icon> &nbsp;
                  <span style="font-size:12px;">{{editedItem.Error}}</span>
                </p> -->
              </div>
              <v-layout class="padding_5_20" wrap>
                <v-container width="w-100" class="ma-0 pa-0" style="max-width:2000px;">
                  <v-row class="ma-0 pa-0">
                    <v-col cols="6" class="modal-heading">
                      <span class="headline pull-left"><strong v-if="editedItem.TransactionType == 'Order'">Ship to:
                        </strong>
                        {{ editedItem.CustomerDescription }} ({{
                          editedItem.CustomerId
                        }})</span>
                    </v-col>
                    <v-col cols="6" class="modal-heading">
                      <span v-if="editedItem.TransactionType == 'Order'" class="headline pull-left"><strong>Bill to:
                        </strong>
                        {{ editedItem.BillToCustomerDescription }} ({{
                          editedItem.BillToCustomerId
                        }})
                      </span>
                      <!-- <div v-if="pendingAgreementSettingStatus == true" class="headline padding_left_78percent"> -->
                      <div class="headline padding_left_78percent">
                        <div class="row body-2">
                          <v-row v-if="pendingAgreementSettingStatus == true">
                            <v-col cols="2" class="pa-0">
                              <v-icon v-if="((IsProUser == true)
                                && (editedItem.IsPendingFileFlob)
                                && (editedItem.PrintFailedError == null || editedItem.PrintFailedError == '')
                                && (editedItem.Status == 1 || editedItem.Status == 2)
                                && (editedItem.OriginalBookingNumber !== null && editedItem.OriginalBookingNumber != 'duplicate')
                                && pendingAgreementSettingStatus == true
                                && (id == 'pending' || id == 'approved' || id == 'Quotes' || editedItem.IsVoidFailed))"
                                color="blue-grey darken-2" class="ml-0 pl-0 mr-0 pr-0 font_xlarge"
                                @click="DownloadItem(editedItem, 'pending')">mdi-file-pdf-box
                              </v-icon>
                            </v-col>
                            <v-col cols="10" class="pa-0" >
                              <span v-if="(id == 'pending' || id == 'approved' || id == 'Quotes' || editedItem.IsVoidFailed) && editedItem.TransactionType == 'Book' && editedItem.OriginalBookingNumber" class="font-sizeSmaller">Pending Booking: </span>
                              <span v-if="(id == 'pending' || id == 'approved' || id == 'Quotes' || editedItem.IsVoidFailed) && editedItem.TransactionType == 'Prepay' && editedItem.OriginalBookingNumber" class="font-sizeSmaller">Pending Prepay: </span>
                              <span v-if="(id == 'pending' || id == 'approved' || id == 'Quotes' || editedItem.IsVoidFailed) && editedItem.TransactionType == 'Quote' && editedItem.OriginalBookingNumber" class="font-sizeSmaller">Pending Quote: </span>
                              <span  v-if="(id == 'pending' || id == 'approved' || id == 'Quotes' || editedItem.IsVoidFailed) && editedItem.OriginalBookingNumber" class="font-sizeSmaller">{{editedItem.OriginalBookingNumber }}</span>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="2" class="pa-0" v-if="pendingAgreementSettingStatus == true">
                              <v-icon
                                v-if="((IsProUser == true) && (editedItem.IsApprovedFileFlob) && (editedItem.PrintFailedError == null || editedItem.PrintFailedError == '') && (editedItem.Status == 2) && (editedItem.BookingNumber !== null) && pendingAgreementSettingStatus == true && (id == 'approved' || editedItem.IsVoidFailed))"
                                color="blue-grey darken-2" class="ml-0 pl-0 mr-0 pr-0 font_xlarge"
                                @click="DownloadItem(editedItem, 'approved')">mdi-file-pdf-box</v-icon>
                            </v-col>
                            <v-col cols="10" class="pa-0" >
                              <span v-if="(id == 'approved' || editedItem.IsVoidFailed) && editedItem.TransactionType == 'Book'" class="font-sizeSmaller">Approved Booking: </span>
                              <span v-if="(id == 'approved' || editedItem.IsVoidFailed) && editedItem.TransactionType == 'Prepay'" class="font-sizeSmaller">Approved Prepay: </span>
                              <span v-if="(id == 'approved' || editedItem.IsVoidFailed) && editedItem.TransactionType == 'Order'" class="font-sizeSmaller">Approved Order: </span>
                              <span v-if="(id == 'approved' || editedItem.IsVoidFailed)" class="font-sizeSmaller">{{ editedItem.BookingNumber}}</span>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0 pa-0">

                    <v-col cols="2" v-if="editedItem.TransactionType == 'Order'">
                      <span>
                        <v-autocomplete variant="underlined" color="primary" label="Pickup/Delivery"
                          v-model="editedItem.PickupDelivery" :items="pickupDeliveryList" :readonly="false"
                          item-title="Description" item-value="Code" prepend-icon="mdi-city">
                        </v-autocomplete>
                      </span>
                    </v-col>
                    <v-col class="padding_right_5" cols="2" v-if="editedItem.TransactionType == 'Order'">
                      <span>
                        <v-autocomplete label="Order Status" variant="underlined" color="primary"
                          v-model="editedItem.OrderStatus" :items="orderStatuses" :readonly="false" item-title="value"
                          item-value="id" prepend-icon="mdi-city">
                        </v-autocomplete>
                      </span>
                    </v-col>
                    <v-col cols="2" class="padding_right_5">
                      <span>
                        <v-text-field v-if="editedItem.TransactionType == 'Book'" label="Booking Amount"
                          v-model="editedItem.TotalPrice" :prefix="currency" disabled variant="underlined"
                          color="primary">
                        </v-text-field>
                        <v-text-field v-if="editedItem.TransactionType == 'Prepay'" label="Prepay Amount"
                          :prefix="currency" v-model="editedItem.TotalPrice" disabled variant="underlined"
                          color="primary">
                        </v-text-field>
                        <v-text-field v-if="editedItem.TransactionType == 'Order'" label="Order Amount" :prefix="currency"
                          variant="underlined" color="primary" v-model="editedItem.TotalPrice" disabled>
                        </v-text-field>
                      </span>
                    </v-col>
                    <v-col cols="2" class="padding_right_5">
                      <span>
                        <v-text-field variant="underlined" color="primary" label="Available Credit"
                          v-model="editedItem.CreditAvailable" :prefix="currency" disabled>
                        </v-text-field>
                      </span>
                    </v-col>
                    <v-col cols="1" class="padding_right_5">
                      <span>
                        <v-text-field label="User" v-model="editedItem.BookingUser" disabled variant="underlined"
                          color="primary">
                        </v-text-field>
                      </span>
                    </v-col>
                    <v-col cols="3" class="padding_right_5">
                      <span>
                        <v-autocomplete label="Location" disabled v-model="editedItem.Location" :items="locations"
                          variant="underlined" color="primary" :readonly="false" item-title="Description"
                          item-value="Code" prepend-icon="mdi-city">
                        </v-autocomplete>
                      </span>
                    </v-col>
                    <v-col cols="2" class="padding_right_5" v-if="editedItem.TransactionType == 'Prepay'">
                      <span>
                        <v-text-field label="Check Amount" :prefix="currency" v-model="editedItem.CheckAmount"
                          variant="underlined" color="primary" disabled>
                        </v-text-field>
                      </span>
                    </v-col>
                    <v-col cols="2" class="padding_right_5" v-if="editedItem.TransactionType == 'Prepay'">
                      <span>
                        <v-text-field label="Prepay Check #" v-model="editedItem.CheckNumber" disabled
                          variant="underlined" color="primary">
                        </v-text-field>
                      </span>
                    </v-col>
                    <v-col cols="2" class="padding_right_5" v-if="editedItem.TransactionType == 'Prepay'">
                      <span>
                        <v-text-field label="Check Postmark Date" v-model="editedItem.CheckDate" disabled
                          variant="underlined" color="primary">
                        </v-text-field>
                      </span>
                    </v-col>
                    <v-col cols="2" v-if="editedItem.TransactionType == 'Prepay'">
                      <v-autocomplete label="Bank Code" v-model="editedItem.BankCode" :items="bankCodes" :readonly="false"
                        item-title="BankName" item-value="Code" prepend-icon="mdi-city" variant="underlined"
                        color="primary">
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="2" class="padding_right_5" v-if="editedItem.TransactionType == 'Order'">
                      <span>
                        <v-text-field v-bind:label="orderField1Label" maxlength="10" v-model="editedItem.OrderField1"
                          variant="underlined" color="primary"></v-text-field>
                      </span>
                    </v-col>
                    <v-col class="padding_right_5" cols="2" v-if="editedItem.TransactionType == 'Order'">
                      <span>
                        <v-text-field v-bind:label="orderField2Label" maxlength="10" v-model="editedItem.OrderField2"
                          variant="underlined" color="primary">
                        </v-text-field>
                      </span>
                    </v-col>
                    <v-col class="padding_right_5" cols="2" v-if="editedItem.TransactionType == 'Order'">
                      <span>
                        <v-text-field v-bind:label="orderField3Label" maxlength="10" variant="underlined" color="primary"
                          v-model="editedItem.OrderField3">
                        </v-text-field>
                      </span>
                    </v-col>
                    <v-col cols="2" class="padding_right_5" v-if="editedItem.TransactionType == 'Order'">
                      <span class="pull-right" :class="isOrderRemarksAvailable == false ? 'tooltip' : ''">
                        <v-btn variant="outlined" outlined color="green darken-2"
                          :disabled="isOrderRemarksAvailable == false" @click="dialogRemarks = true">
                          View All Remarks
                        </v-btn>
                        <span v-if="isOrderRemarksAvailable == false" class="tooltiptext">There are no remarks for this
                          order</span>
                      </span>
                    </v-col>
                    <br />
                    <v-col cols="2" class="padding_right_5" v-if="editedItem.Signature">
                      <span>
                        Signature :
                        <img width="150" height="auto" v-bind:src="'data:image/jpeg;base64,' + editedItem.Signature
                          " />
                      </span>
                    </v-col>
                    <br />
                    <v-col cols="2" v-if="id == 'Quotes'">
                      <v-switch v-model="editedItem.IsAlert" color="success" label="Review needed"></v-switch>

                    </v-col>
                    <br />
                    <v-col cols="12" class="padding_right_5" v-if="editedItem.comments">
                      <span class="grey--text">{{ editedItem.comments }}</span>
                    </v-col>
                    <v-col cols="12" v-if="editedItem.Remarks">
                      <strong>Remarks:</strong>
                      {{ editedItem.Remarks }} 
                      <span v-if="editedItem.Farm">  
                      <strong>, Farm:</strong>
                      {{ editedItem.Farm }}   
                     </span>      
                     <span v-if="editedItem.Field">  
                      <strong>, Field:</strong>
                      {{ editedItem.Field }}   
                     </span>       
                    </v-col>
                    <br />
                  </v-row>
                </v-container>


              </v-layout>

              <v-data-table :headers="getProductHeaders()" :items="editedItem.products"
                :rows-per-page-items="[10, 20, 35]" class="elevation-1 items_table" density="compact">
                <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
                  <tr>
                    <template v-for="column in columns" :key="column.key">

                      <td v-if="column.key == 'ProuductDescription'" class="pa-0 column text-h6 text-center"
                        style="width:8%;">
                        <span class="cursor-pointer" @click="() => toggleSort(column)"
                          style="font-size: 12px !important;">{{ column.title }}</span>
                        <template v-if="isSorted(column)">
                          <v-icon :icon="getSortIcon(column)"></v-icon>
                        </template>
                      </td>

                      <td v-else-if="column.key == 'Quantity'" class="pa-0 column text-h6 text-center" style="width:8%;">
                        <span class="cursor-pointer" @click="() => toggleSort(column)"
                          style="font-size: 12px !important;">{{ column.title }}</span>
                        <template v-if="isSorted(column)">
                          <v-icon :icon="getSortIcon(column)"></v-icon>
                        </template>
                      </td>
                      <td v-else-if="column.key == 'Price'" class="pa-0 column text-h6 text-center" style="width:8%;">
                        <span class="cursor-pointer" @click="() => toggleSort(column)"
                          style="font-size: 12px !important;">{{ column.title }}</span>
                        <template v-if="isSorted(column)">
                          <v-icon :icon="getSortIcon(column)"></v-icon>
                        </template>
                      </td>

                      <td v-else class="pa-0 column text-h6 text-center">
                        <span class="cursor-pointer " @click="() => toggleSort(column)"
                          style="font-size: 12px !important;">{{ column.title }}</span>
                        <template v-if="isSorted(column)">
                          <v-icon :icon="getSortIcon(column)"></v-icon>
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-center pa-0">{{ item.ProductId }}</td>
                    <td class="text-center pa-0">
                      {{ item.ProductDescription }}
                    </td>
                    <td class="text-center pa-0">
                      <v-text-field :rules="[rules.quantitiesRules]"
                        :disabled="(id == 'approved') || (!AllowedEdit && id != 'approved')"
                        v-bind:precision="productQuantityPrecision" type="number" v-model="item.Quantity"
                        @keypress="onlyForCurrency" @blur="FixQuantityDecimalPlace(item)">
                      </v-text-field>
                    </td>
                    <td class="text-left pa-0">
                      <v-text-field :rules="[rules.priceRules]"
                        :disabled="(id == 'approved') || (!AllowedEdit && id != 'approved')" :prefix="currency"
                        v-bind:precision="unitPricePrecision" type="number" v-model="item.Price"
                        @keypress="onlyForCurrency" @blur="FixPriceDecimalPlace(item)">
                      </v-text-field>
                    </td>
                    <td class="text-center pa-0">
                      <span v-if="calculateTotalAmount(item.Quantity,item.Price).indexOf('$') === -1">$ &nbsp;{{calculateTotalAmount(item.Quantity,item.Price)}}</span>
                      <span v-else>{{calculateTotalAmount(item.Quantity,item.Price)}}</span>
                      <!-- $
                      {{
                        calculateTotalAmount(
                          item.Quantity,
                          item.Price
                        )
                      }} -->
                    </td>
                    <td class="text-center date_control pa-0">
                      <input :disabled="!AllowedEdit" type="date" v-model="item.StartDate" />
                    </td>
                    <td class="text-center date_control pa-0">
                      <input :disabled="!AllowedEdit" type="date" v-model="item.EndDate" />
                    </td>
                    <td class="text-center pa-0">{{ item.OnHand }}</td>
                    <td class="text-center pa-0">

                     <!--<v-autocomplete 
                        disabled 
                        @change="changeacitem($event, item, editedItem)"
                        v-model="item.savedLocation" 
                        :items="item.LocationsOnItem" 
                        :readonly="false" 
                        item-text="Location"
                        item-value="Location" 
                        varient="underlined">
                       </v-autocomplete> 
                      -->
                      <v-text-field class="text-center pa-0"
                        disabled
                        v-model="item.savedLocation">
                      </v-text-field>
                    </td>
                    <td class="text-center pa-0">{{ item.SellUom }}</td>
                    <td class="text-center pa-0">{{ item.Position }}</td>
                    <td class="text-center pa-0">{{ item.PriceLevel1 }}</td>
                    <td class="text-center pa-0">
                      {{
                        getVariancePriceLevel(
                          item.Price,
                          item.PriceLevel1
                        )
                      }}
                    </td>
                    <td class="text-center pa-0">{{ item.PriceLevel2 }}</td>
                    <td class="text-center pa-0">
                      {{
                        getVariancePriceLevel(
                          item.Price,
                          item.PriceLevel2
                        )
                      }}
                    </td>
                  </tr>
                </template>
              </v-data-table>


              <v-card-actions style="height: 50px;">
                <v-spacer></v-spacer>
                <v-layout align-start justify-start row fill-height>
                  <span v-if="id == 'pending' || id == 'failed'">
                    <span class="pull-right pl-2 pr-2" :class="editedItem.TransactionType == 'Order' &&
                      isOrderPermission == false
                      ? 'tooltip'
                      : ''
                      ">
                      <v-btn variant="outlined" outlined color="green darken-2"
                        @click.native="approveBooking(editedItem, false, true)" :disabled="editedItem.TransactionType == 'Order' &&
                          isOrderPermission == false
                          ">
                        Approve
                        <v-icon right dark>mdi-check-circle</v-icon>
                      </v-btn>
                      <span v-if="editedItem.TransactionType == 'Order' &&
                        isOrderPermission == false
                        " class="tooltiptext">Please set up (INV - Import Orders) security to level 3
                        or higher in AGRIS.</span>
                      <!-- <v-text v-if="editedItem.TransactionType == 'Order' &&
                        isOrderPermission == false
                        " class="tooltiptext">Please set up (INV - Import Orders) security to level 3
                        or higher in AGRIS.</v-text> -->
                    </span>
                    <v-btn variant="outlined" v-if="!editedItem.IsVoidFailed" outlined color="error darken-2"
                      @click.native="declineBooking(editedItem, true)">
                      Decline
                      <v-icon right dark>mdi-close-circle-outline</v-icon>
                    </v-btn>
                    <v-btn variant="outlined" outlined color="info darken-2" :disabled="(orderField1Required && editedItem.OrderField1 == '') ||
                      (orderField2Required && editedItem.OrderField2 == '') ||
                      (orderField3Required && editedItem.OrderField3 == '')
                      " @click.native="saveBooking(editedItem)">
                      Save
                      <v-icon right dark>mdi-content-save-outline</v-icon>
                    </v-btn>
                  </span>
                  <span v-if="id == 'Quotes'">
                    <v-btn variant="outlined" outlined color="info darken-2" :disabled="(orderField1Required && editedItem.OrderField1 == '') ||
                      (orderField2Required && editedItem.OrderField2 == '') ||
                      (orderField3Required && editedItem.OrderField3 == '')
                      " @click.native="saveBooking(editedItem)">
                      Save
                      <v-icon right dark>mdi-content-save-outline</v-icon>
                    </v-btn>
                  </span>
                  <v-btn variant="outlined" outlined color="warn darken-2" @click.native="close()">Exit</v-btn>
                  <v-progress-linear :indeterminate="true" height="5" color="green"
                    v-if="actioninProgress"></v-progress-linear>
                </v-layout>
              </v-card-actions>
            </v-card>
          </form>
        </v-dialog>

        <v-dialog persistent v-model="dialogRemarks" max-width="95%">
          <v-card class="padding_5_20">
            <v-layout class="ma-0 pa-0 w-100">
              <v-container class="ma-0 pa-0 w-100 " max-width="100%" width="800" style="max-width:2000px;">
                <v-row class="ma-0 pa-0">
                  <v-col cols="12" class="modal-heading">
                    <span class="text-h5 pull-left">Order Remarks</span>
                    <!-- <v-text class="text-h5 pull-left">Order Remarks</v-text> -->
                  </v-col>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <v-col class="padding_right_5" cols="6" v-for="remarks in orderRemarks" :key="remarks.OrderRemarksId">
                    <v-text-field disabled v-bind:label="remarks.Label" v-model="remarks.Value" />
                  </v-col>
                </v-row>
              </v-container>
            </v-layout>
            <v-card-actions style="height: 50px;">
              <v-spacer />
              <v-layout align-start justify-start row fill-height>
                <v-btn variant="outlined" color="warn darken-2" @click="dialogRemarks = false">Exit</v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </div>
      </v-sheet>
    </transition>
  </div>
</template>
<script>
// eslint-disable-next-line
/* eslint-disable */
import DataService from "@/services/data-service";
const dataService = new DataService();
import RequestHelperService from "../services/request-helper-service";
const requestHelper = new RequestHelperService();
import Helpers from "@/services/helpers";
const helpers = new Helpers();
helpers.enableLogging = true;


import SentryService from "@/services/sentry-service";
const sentryService = new SentryService();

import moment from "moment";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {
  AppSettingConfigurations,
  PendingAgreementConfigurations,
} from "../constants/index";
// import ErrorTypes from "../enums/index";
import CryptoService from "@/services//crypto-services";
import { saveAs } from "file-saver";
import { SentryTag } from "@/models";
import { compare, compareVersions } from 'compare-versions';

const remoteURL = process.env.VUE_APP_REMOTE_URL;

const cryptoService = new CryptoService();
export const AlertTypes = {
  Approve: "approve",
  Decline: "decline",
  Error: "error",
};

export const TransactionTypes = {
  Book: "Book",
  Prepay: "Prepay",
  Order: "Order",
};

export default {
  name: "bookings",
  props: ["id"],
  _loading: true,
  data: () => ({
    //sortBy: [],
    testId :"",
    pendingAgreementSettingStatus: false,
    pendingAgreementSettingBookingStatus: "",
    pendingAgreementSettingPrepayStatus: "",
    approveAlert: false,
    declineAlert: false,
    errorAlert: false,
    alertText: "",
    bankCodes: [],
    isFiltered: false,
    dateDialog: false,
    maxLength: 300,
    snackbar: false,
    productQuantityPrecision: 4,
    unitPricePrecision: 4,
    searchColumn: "",
    snackbarText: "",
    isLoading: false,
    wrongInputDialog: false,
    detaildialog: false,
    errorDialog: false,
    dialogRemarks: false,
    endMenu: false,
    startMenu: false,
    dialogDoneComments: false,
    dialogDeclineComments: false,
    dialogSuccess: false,
    actioninProgress: false,
    errorOrsuccessMessage: "",
    editedIndex: -1,
    editedItem: {},
    editedItemLocation: "",
    defaultItem: {},
    search: '',
    appliedColumnFilters: {},
    confirmDialog: false,
    orderRemarks: [],
    isOrderRemarksAvailable: false,
    orderStatuses: [],
    isOrderPermission: false,
    orderField1Label: "",
    orderField2Label: "",
    orderField3Label: "",
    orderField1Required: false,
    orderField2Required: false,
    orderField3Required: false,
    errorDialogText: "",
    currency: "$",
    showExpiredQuotes: false,
    showDeletedQuotes: false,
    IsProUser: false,
    rowsPerPageItems: [10, 20, 30, 40, 50],
    pagination: {
      page: 1,
      rowsPerPage: 10,
      sortBy: [{ key: "BookingTimestamp", order: "asc" }],
    },
    totalBookings: 0,
    BookingTimestamp: "BookingTimestamp",
    selected: [],
    sortBy: [{ key: 'BookingTimestamp', order: 'desc' }],
    fields: [
      "Location",
      "BookingTimestamp",
      "OriginalBookingNumber",
      "CustomerId",
      "CustomerDescription",
      "CreditAvailable",
      "TotalPrice",
      "TransactionType",
      "Signature",
      "StartDate",
      "EndDate",
      "BookingUser",
      "ApproveTimestamp",
      "BookingNumber",
      "Deleted",
      "DeletedBy",
      "DeletedTimeStamp",
      "ExpiryDate",
      "Actions",
    ],
    headers: [
      {
        text: "Location",
        title: "Location",
        value: "Location",
        key: "Location",
        align: "text-center",
        width: "1px",
        visibility: "hidden-xs-only",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Entry Date/Time",
        value: "BookingTimestamp",
        title: "Entry Date/Time",
        key: "BookingTimestamp",
        align: "text-center",
        width: "12%",
        isSearched: false,
        searchedText: "",
       
      },
      {
        text: "Pending #",
        value: "OriginalBookingNumber",
        title: "Pending #",
        key: "OriginalBookingNumber",
        align: "text-center",
        width: "8%",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Customer Id",
        value: "CustomerId",
        title: "Customer Id",
        key: "CustomerId",
        align: "text-left",
        width: "9%",
        visibility: "hidden-xs-only",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Customer Name",
        value: "CustomerDescription",
        title: "Customer Name",
        key: "CustomerDescription",
        align: "text-left",
        width: "10%",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Available Credit",
        value: "CreditAvailable",
        title: "Available Credit",
        key: "CreditAvailable",
        align: "text-right",
        width: "10%",
        visibility: "hidden-xs-only",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Total $",
        value: "TotalPrice",
        title: "Total $",
        key: "TotalPrice",
        align: "text-center",
        width: "1%",
        visibility: "hidden-xs-only",
        class: "font_small",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Type",
        value: "TransactionType",
        title: "Type",
        key: "TransactionType",
        align: "text-center",
        width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
        searchedText: "",
      },
      {

        text: "Sig",
        value: "Signature",
        title: "Sig",
        key: "Signature",
        align: "text-center",
        width: "2px",
        visibility: "hidden-xs-only",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Start Date",
        value: "StartDate",
        title: "Start Date",
        key: "StartDate",
        align: "text-center",
        width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "End Date",
        value: "EndDate",
        title: "End Date",
        key: "EndDate",

        align: "text-center",
        width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
        searchedText: "",
      },

      {
        text: "User",
        value: "BookingUser",
        title: "User",
        key: "BookingUser",

        align: "text-center",
        width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Decline Date/Time",
        value: "ApproveTimestamp",
        title: "Decline Date/Time",
        key: "ApproveTimestamp",
        align: "text-center",
        width: "1%",
        isSearched: false,
        searchedText: "",
      },

      {
        text: "Transaction #",
        value: "BookingNumber",
        title: "Transaction #",
        key: "BookingNumber",
        align: "text-center",
        width: "1%",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Deleted By",
        value: "DeletedBy",
        title: "Deleted By",
        key: "DeletedBy",
        align: "text-center",
        width: "1%",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Delete at",
        value: "DeletedTimeStamp",
        title: "Delete at",
        key: "DeletedTimeStamp",
        align: "text-center",
        width: "1%",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Expiry Date",
        value: "ExpiryDate",
        title: "Expiry Date",
        key: "ExpiryDate",
        align: "text-center",
        width: "1%",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Agris Response",
        value: "Error",
        title: "Agris Response",
        key: "Error",
        align: "text-center",
        width: "5%",
        isSearched: false,
        searchedText: "",
      },
      {
        text: "Actions",
        value: "Actions",
        title: "Actions",
        key: "Actions",
        align: "text-center",
        width: "10%",
        isSearched: false,
        searchedText: "",
      },
    ],
    productHeaders: [
      {
        text: "Product Id",
        value: "ProductId",
        title: "Product Id",
        key: "ProductId",
        align: "text-center",
        //width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Description",
        value: "ProuductDescription",
        title: "Description",
        key: "ProuductDescription",
        align: "text-center",
        width: "2%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Quantity",
        value: "Quantity",
        title: "Quantity",
        key: "Quantity",
        align: "text-center",
        width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Price",
        value: "Price",
        title: "Price",
        key: "Price",
        align: "text-center",
        width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Amount",
        value: "Amount",
        title: "Amount",
        key: "Amount",
        align: "text-center",
        //width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Start Date",
        value: "StartDate",
        title: "Start Date",
        key: "StartDate",
        align: "text-center",
        // width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "End Date",
        value: "EndDate",
        title: "End Date",
        key: "EndDate",
        align: "text-center",
        // width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "On Hand",
        value: "OnHand",
        title: "On Hand",
        key: "OnHand",
        align: "text-center",
        //width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Location",
        value: "Location",
        title: "Location",
        key: "Location",
        align: "text-center",
        width: "5%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "UOM",
        value: "salloum",
        title: "UOM",
        key: "salloum",
        align: "text-center",
        // width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Position",
        value: "Position",
        title: "Position",
        key: "Position",
        align: "text-center",
        //width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Price Level 1",
        align: "text-center",
        title: "Price Level 1",

        // width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Var PL 1",
        align: "text-center",
        title: "Var PL 1",

        // width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Price Level 2",
        title: "Price Level 2",
        align: "text-center",
        // width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
      {
        text: "Var PL 2	",
        title: "Var PL 2	",
        align: "text-center",
        // width: "1%",
        visibility: "hidden-xs-only",
        isSearched: false,
      },
    ],
    bookings: [],
    originalBookings: [],
    locations: [],
    pickupDeliveryList: [
      { Code: "P", Description: "Pickup" },
      { Code: "D", Description: "Delivery" },
    ],
    export_fields: {
      "Customer Id": "CustomerId",
      "Customer Name": "CustomerDescription",
      "Available Credit": "CreditAvailable",
      "Total $": "TotalPrice",
      Signature: {
        field: "Signature",
        callback: (value) => {
          return value ? "Yes" : "No";
        },
      },
      "By Phone": {
        field: "IsByPhone",
        callback: (value) => {
          return value ? "Yes" : "No";
        },
      },
      "Start Date": "StartDate",
      "End Date": "EndDate",
      Location: "Location",
      User: "BookingUser",
      ApproveTimestamp: "ApproveTimestamp",
      "Entry Date/Time": "BookingTimestamp",
    },
    rules: {
      quantitiesRules: value => (!!value && value.length <= 10) || "maximum limit is 10 digits",
      priceRules: value => (!!value && value.length <= 10) || "maximum limit is 10 digits",
    },

    quantitiesRules: [
      (v) => (!!v && v.length <= 10) || "maximum limit is 10 digits",
    ],
    priceRules: [
      (v) => (!!v && v.length <= 10) || "maximum limit is 10 digits",
    ],
    AgrisCurrentversion: "",
    AgrisUpdateAllowedVersion: "",
    AllowedEdit: false,
    showDialog: false,

  }),
  components: {
    Loading,
  },
  computed: {
    hasColumnFilters() {
      return this.headers.some((h) => h.searchedText && h.searchedText.trim());
    },
    displayedBookings() {
      const term = (this.search || "").trim().toLowerCase();
      if (!term) return this.bookings;
      const columns = this.getHeaders()
        .map((h) => h.value)
        .filter((c) => c !== "Actions" && c !== "Signature");
      return this.bookings.filter((item) =>
        columns.some((c) => this.quickFilterValue(item, c).toLowerCase().includes(term))
      );
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Actions";
    },
    // capitalize: function (value) {
    //   if (!value) return "";
    //   value = value.toString();
    //   return value.charAt(0).toUpperCase() + value.slice(1);
    // },
    // roundoff2decimel: function (value) {
    //   var result = Number(value).toFixed(2); // 6.7
    //   return result;
    // },
    // roundoff4decimel: function (value) {
    //   var result = Number(value).toFixed(4); // 6.7
    //   return result;
    // },
  
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      this.testId =value;
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
   
    // roundoff2decimel: function (value) {
    //   var result = Number(value).toFixed(2); // 6.7
    //   return result;
    // },
    // roundoff4decimel: function (value) {
    //   var result = Number(value).toFixed(4); // 6.7
    //   return result;
    // },
  },
  watch: {
    detaildialog(val) {
      val || this.close();
    },
    dialogDeclineComments() {
      val || this.cancelDecline();
    },
    $route(to, from) {
      helpers.log(to.params.id);
      this.resetSearchedText();
      this.appliedColumnFilters = {};
      this.search = "";
      this.pagination.page = 1;
      this.totalBookings = 0;
      this.initialize();
    },
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    next();
  },

  created() {
    this.isFiltered = localStorage.getItem("enablefilter") == "true";

    this.IsProUser =
      cryptoService.dencryptString(localStorage.getItem("ProUser")) === "true";
    this.initialize();
  },
  methods: {

    capitalized(name) {
      const capitalizedFirst = name[0].toUpperCase();
      const rest = name.slice(1);
      this.testId =capitalizedFirst + rest;
      return capitalizedFirst + rest;
    },
    async initialize() {

      this.AgrisCurrentversion = localStorage.getItem("AgrisVersion");
      this.AgrisUpdateAllowedVersion = "23.0.0";
      if (this.AgrisCurrentversion) {
        this.AllowedEdit = compare(this.AgrisCurrentversion, this.AgrisUpdateAllowedVersion, '>=');
      } else {
        this.AllowedEdit = compare('22.0.0', this.AgrisUpdateAllowedVersion, '>=');
      }

      if (this.id === "declined") {
        this.changeSort("ApproveTimestamp");
      } else {
        this.changeSort("BookingTimestamp");
      }
      await this.getAppSettings();
      this.getDataFromServer();
    },
    getTableClass() {
      // Determine the appropriate CSS class based on the ID value
      return {
        'failed-width': this.testId === 'Failed',
        'Quote-width': this.testId === 'Quotes',
        'default-width': this.testId !== 'Failed' && this.testId !=='Quotes'
      };
    },
    itemRowBackground(item) {
      if (this.id == "Quotes") {
        if (item.IsDeleted) return "row_deleted";
        else if (item.IsExpired) return "row_expired";
      }
    },
    onChangeStartDate() {
      let newEndDate = moment(this.editedItem.ControlStartDate).add(
        1,
        "Months"
      );
      // this.editedItem.ControlEndDate = this.formatDate(
      //   newEndDate,
      //   "MM/DD/YYYY"
      // );
      this.editItem.ControlEndDate = moment(newEndDate)
        .format("YYYY-MM-DD")
        .toString();
      this.editedItem.EndDate = this.formatDate(newEndDate, "MM/DD/YYYY");
    },
    saveDate(menu, item) {
      menu.save(this.formatDate(item.ControlStartDate));
      item.StartDate = this.formatDate(item.ControlStartDate, "MM/DD/YYYY");
    },
    FixPriceDecimalPlace(value, booking) {
      if (
        value.Price.indexOf(".") > -1 &&
        value.Price.split(".")[1].length >
        event.target.attributes.precision.value
      ) {
        value.Price =
          value.Price.split(".")[0] +
          "." +
          value.Price.substr(
            value.Price.indexOf(".") + 1,
            event.target.attributes.precision.value
          );
      }
      let totalPrice = 0;
      let products = booking.products || [];
      products.forEach((element) => {
        totalPrice += (element.Price * element.Quantity);
      });
      let fn = this.formatPrice(Number(totalPrice));
      this.$set(booking, 'TotalPrice', fn);
    },
    FixQuantityDecimalPlace(value, booking) {
      if (
        value.Quantity.indexOf(".") > -1 &&
        value.Quantity.split(".")[1].length >
        event.target.attributes.precision.value
      ) {
        value.Quantity =
          value.Quantity.split(".")[0] +
          "." +
          value.Quantity.substr(
            value.Quantity.indexOf(".") + 1,
            event.target.attributes.precision.value
          );
      }
      let totalPrice = 0;
      let products = booking.products || [];
      products.forEach((element) => {
        totalPrice += (element.Price * element.Quantity);
      });
      let fn = this.formatPrice(Number(totalPrice));
      this.$set(booking, 'TotalPrice', fn);
    },
    onlyForCurrency: function (event) {
      if (event.keyCode === 8) return;
      if (event.keyCode === 101) {
        event.preventDefault();
        return false;
      }
      let keyCode = event.keyCode ? event.keyCode : event.which;
      let value = event.target.value;
      if (
        (value.length === 14 && value.indexOf(".") > -1) ||
        value.length === 13
      ) {
        event.preventDefault();
        return false;
      }
      //  if(((value.length==14 && value.indexOf('.') > -1) || value.length == 13) ||
      //  (value.indexOf(".")>-1 && (value.split('.')[1].length > event.target.attributes.precision.value - 1 || value.length == 13))
      //  ){

      //    event.preventDefault();
      //    return false;
      //  }

      // restrict to 2 decimal places
      //  if(value!==null && value.indexOf(".")>-1 && (value.split('.')[1].length > event.target.id - 1)){
      //  $event.preventDefault();
      //  }
    },

    getHeaders() {
      return this.headers.filter((header) => {
        return (
          (this.id == "pending" &&
            header.value !== "Error" &&
            header.value !== "BookingNumber" &&
            header.value !== "ApproveTimestamp" &&
            header.value !== "DeletedTimeStamp" &&
            header.value !== "ExpiryDate" &&
            header.value !== "DeletedBy") ||
          (this.id == "approved" &&
            header.value !== "ApproveTimestamp" &&
            header.value !== "OriginalBookingNumber" &&
            header.value !== "Error" &&
            header.value !== "DeletedTimeStamp" &&
            header.value !== "ExpiryDate" &&
            header.value !== "DeletedBy") ||
          (this.id == "declined" &&
            header.value !== "Error" &&
            header.value !== "OriginalBookingNumber" &&
            header.value !== "BookingNumber" &&
            header.value !== "DeletedTimeStamp" &&
            header.value !== "ExpiryDate" &&
            header.value !== "DeletedBy") ||
          (this.id == "failed" &&
            header.value !== "ApproveTimestamp" &&
            header.value !== "BookingNumber" &&
            header.value !== "DeletedTimeStamp" &&
            header.value !== "ExpiryDate" &&
            header.value !== "DeletedBy") ||
          (this.id == "Quotes" &&
            header.value !== "BookingNumber" &&
            (this.showDeletedQuotes || header.value !== "DeletedTimeStamp") &&
            (this.showDeletedQuotes || header.value !== "DeletedBy") &&
            (this.showExpiredQuotes || header.value !== "ExpiryDate") &&
            header.value !== "ApproveTimestamp" &&
            header.value !== "Error")
        );
      });
    },

    getExportFields() {
      if (this.id == "approved") {
        this.export_fields["Transaction #"] = "BookingNumber";
        this.export_fields["Pending Transaction #"] = "OriginalBookingNumber";
        delete this.export_fields["Agris Response"];
        delete this.export_fields["ApproveTimestamp"];
      } else if (this.id == "failed") {
        this.export_fields["Agris Response"] = "Error";
        this.export_fields["Pending Transaction #"] = "OriginalBookingNumber";
        //delete this.export_fields["Transaction #"];
        delete this.export_fields["ApproveTimestamp"];
      } else {
        delete this.export_fields["Agris Response"];
        delete this.export_fields["Transaction #"];
      }
      return this.export_fields;
    },
    getProductHeaders() {
      return this.productHeaders.filter((header) => {
        return (
          (this.id == "pending" &&
            header.value !== "Error" &&
            header.value !== "BookingNumber" &&
            header.value !== "ApproveTimestamp") ||
          (this.id == "approved" &&
            header.value !== "Actions" &&
            header.value !== "ApproveTimestamp" &&
            header.value !== "Error") ||
          (this.id == "declined" &&
            header.value !== "Error" &&
            header.value !== "BookingNumber" &&
            header.value !== "Actions") ||
          (this.id == "failed" &&
            header.value !== "ApproveTimestamp" &&
            header.value !== "BookingNumber")
        );
      });
    },
    changeacitem(event, item, booking) {
      
      item.selectedLocation = event;
      this.loading = true;
      this._loading = true;
      this.isLoading = true;
      dataService
        .GetProductsFromAgris([item.ProductId], item.selectedLocation)
        .then((agrisItems) => {
          if (agrisItems && agrisItems.length > 0) {
            this.$set(item, "Price", agrisItems[0].SellingPrice1.toString());
            let totalPrice = 0;
            booking.products.forEach((element) => {
              totalPrice += (element.Price * element.Quantity);
            });
            let fn = this.formatPrice(Number(totalPrice));
            this.$set(booking, 'TotalPrice', fn);
          }
        }).finally(() => {
          this.loading = false;
          this._loading = false;
          this.isLoading = false;
        });
    },
    getAgentVersion() {
      dataService
        .getAgentVersion()
        .then((response) => {
          var version = parseInt(
            response.Version.replace(".", "").replace(".", "")
          );
          if (version < 1910) {
            this.maxLength = 50;
          } else {
            this.maxLength = 300;
          }
        })
        .catch((e) => {
          helpers.log(e);
        });
    },
    roundoff2decimel: function (value) {
      var result = Number(value).toFixed(2); // 6.7
      return result;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },
    changeSort(column) {
      switch (column) {
          case 'BookingTimestamp':
            this.sortBy=[];
            this.sortBy = [
              { key: 'BookingTimestamp', order: 'desc' },             
              ];         
            break;
          case 'ApproveTimestamp':       
            this.sortBy=[];
            this.sortBy = [
              { key: 'ApproveTimestamp', order: 'desc' },             
              ];         
            break;
        }

      // if (this.sortBy === column) {
      //   this.pagination.descending = !this.pagination.descending;
      // } else {
      //   this.pagination.sortBy = column;
      //   this.pagination.descending = false;
      // }
    },
    editItem(item, id = "", showDialog = true, retry = false) {
      
      this.isLoading = showDialog;
      this.isOrderRemarksAvailable = false;
      let bookingNumber = item.BookingNumber
        ? item.BookingNumber.includes("-")
          ? item.BookingNumber.split("-")
          : []
        : null;

      if (id.toUpperCase() == "APPROVED" && !item.IsApprovedFileFlob) {
        if (bookingNumber.length > 0) {
          dataService
            .getDocumentAttachmentInfo(bookingNumber[1], bookingNumber[0])
            .then((result) => {
              if (result) {
                this.printtranscation(item, retry, showDialog, false);
              }
            })
            .catch((error) => {
              this.bookingid(item, showDialog, retry);
              // this.isLoading = false;
              helpers.log(error);
            });
        } else {
          this.bookingid(item, showDialog, retry);
          // this.isLoading =false ;
          this.showDialog = true;
        }
      } else {
        this.bookingid(item, showDialog, retry);
        // this.isLoading =false ;
        this.showDialog = true;
      }
    },

    bookingid(item, showDialog, retry) {
      this.loading = true;
      dataService.ValidateAgentSession().finally(() => {
        dataService
          .GetSignatureByBookingId(item.BookingId)
          .then((signature) => {
            if (signature) {
              item.Signature = signature;
            }

            dataService.GetBookingItems(
              item.BookingId,
              item.Location,
              (bookingItems) => {
                let Ids = [];
                let notVoidElements = [];
                bookingItems.forEach(function (value) {
                  if (!value.IsDeleted) {
                    notVoidElements.push(value);
                  }
                });

                this.editItem.products = notVoidElements;
                let headerStartDate = item.StartDate;
                let headerEndDate = item.EndDate;
                this.editItemInternal(
                  item,
                  notVoidElements,
                  0,
                  showDialog,
                  retry
                );
                this.editItem.products = notVoidElements;
                this.editItem.products.forEach((item) => {
                  if (!item.IsDeleted) {
                    Ids.push(item.ProductId);
                    if (item.StartDate == null || item.StartDate == undefined) {
                      item.StartDate = headerStartDate;
                    }
                    if (item.EndDate == null || item.EndDate == undefined) {
                      item.EndDate = headerEndDate;
                    }

                    item.StartDate = this.formatDate(
                      item.StartDate,
                      "YYYY-MM-DD"
                    );
                    item.EndDate = this.formatDate(item.EndDate, "YYYY-MM-DD");
                    item.ControlStartDateMenu = false;
                    item.ControlEndDateMenu = false;
                    item.OriginalPrice = item.Price;
                  }
                });

                dataService
                  .GetProductsFromAgris(Ids, item.Location)
                  .then((agrisItems) => {
                    agrisItems.forEach((agrisItem) => {
                      let editItem = this.editItem.products.filter(
                        (x) => x.ProductId == agrisItem.ItemNumber
                      )[0];
                      editItem.MinimumPrice = agrisItem.MinimumPrice;
                      editItem.MaximumPrice = agrisItem.MaximumPrice;
                    });
                    // item.StartDate = item.StartDate.substr(0, 10);
                    //item.EndDate = item.EndDate.substr(0, 10);
                    dataService.GetOrderRemarks(
                      item.BookingId,
                      (orderRemarks) => {
                        this.orderRemarks = orderRemarks;
                        this.orderRemarks.forEach((remarks) => {
                          if (remarks.Value) {
                            this.isOrderRemarksAvailable = true;
                          }
                        });
                      },
                      (error) => {
                        this.isLoading = false;
                      }
                    );
                  })
                  .catch((error) => {
                    this.isLoading = false;
                    helpers.log(error);
                  });
              },
              (error) => {
                this.isLoading = false;
              }
            );
          })
          .catch((error) => {
            this.isLoading = false;
            helpers.log(error);
          });
      });
    },

    printtranscation(
      item,
      retry = false,
      showDialog = false,
      printRetry = false
    ) {
      this.loading = true;
      dataService.ValidateAgentSession().finally(() => {
        var userInfo = JSON.parse(localStorage.usertData);
        var agentInfo = JSON.parse(localStorage.agentInfo);
        this.isLoading = !printRetry;

        var booking = this.bookings.filter(
          (x) => x.BookingId == item.BookingId
        )[0];
        if (printRetry)
          this.updateDatatableWithMessage(booking, 0, "Printing...");
        let IsSameNumber =
          localStorage.getItem("isSameNumber") === "true" ? true : false;
        let IsProUser =
          cryptoService.dencryptString(localStorage.getItem("ProUser")) ===
            "true"
            ? true
            : false;

        var approveBooking = {
          Id: item.BookingId,
          User: userInfo.userEmail,
          Password: userInfo.Password,
          AgrisSession: userInfo.AgrisSessionId,
          SessionId: agentInfo.SessionID,
          TenantId: agentInfo.TenantId,
          BankCode: item.BankCode,
          isSameNumber:
            IsProUser == true &&
              IsSameNumber == true &&
              item.TransactionType == "Book" &&
              item.BookingNumber &&
              this.pendingAgreementSettingStatus
              ? true
              : false,
        };

        if (printRetry) this.detaildialog = false;

        dataService
          .printTransaction(approveBooking)
          .then((PrintResult) => {
            if (PrintResult.TransactionMessage == "Form Printed") {
              item.IsApprovedFileFlob = true;
              this.isLoading = false;
              if (!printRetry) {
                this.bookingid(item, showDialog, retry);
              } else {
                this.updateDatatableWithMessage(booking, 1, "Form Printed...");
              }
            } else {
              this.updateDatatableWithMessage(
                booking,
                2,
                `Print Failed. Error: ${PrintResult.ErrorMessage}`
              );
            }
          })
          .catch((error) => {
            if (!printRetry) {
              this.bookingid(item, showDialog, retry);
            } else {
              this.updateDatatableWithMessage(
                booking,
                2,
                `Print Failed. Error: ${error}`
              );
            }

            this.isLoading = false;
            helpers.log(error);
          });
      });
    },
    async deletequote(booking) {
      this.$confirm({
        message: "Are you sure you want to delete this quote?",
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            var userInfo = JSON.parse(localStorage.usertData);
            var agentInfo = JSON.parse(localStorage.agentInfo);
            var voidBooking = {
              Id: booking.BookingId,
              User: userInfo.userEmail,
              Password: userInfo.Password,
              AgrisSession: userInfo.AgrisSessionId,
              SessionId: agentInfo.SessionID,
              TenantId: agentInfo.TenantId,
              Status: "V",
              isFromDecline: true,
            };
            if (booking.BookingNumber) {
              this.updateDatatableWithMessage(
                booking,
                0,
                "Voiding pending quote..."
              );
              dataService.approveBooking(voidBooking, async (res) => {
                if (res.TransactionObject) {
                  dataService.deleteBooking(
                    voidBooking,
                    (response) => {
                      this.updateDatatableWithMessage(
                        booking,
                        2,
                        "Quote voided and deleted."
                      );
                    },
                    (error) => {
                      helpers.log(error);
                      this.isLoading = false;
                      this.updateDatatableWithMessage(
                        booking,
                        2,
                        "Transaction failed, error: " + error
                      );
                    }
                  );
                } else {
                  this.updateDatatableWithMessage(
                    booking,
                    2,
                    "Quote void failed. Error : " + res.ErrorMessage
                  );
                }
              });
            } else {
              dataService.deleteBooking(
                voidBooking,
                (response) => {
                  this.updateDatatableWithMessage(booking, 2, "Quote deleted.");
                },
                (error) => {
                  helpers.log(error);
                  this.isLoading = false;
                  this.updateDatatableWithMessage(
                    booking,
                    2,
                    "Transaction failed, error: " + error
                  );
                }
              );
            }
          }
        },
      });
    },
    getAgrisDecimalPrecision() {
      dataService
        .getAgrisDecimalPricision()
        .then((response) => {
          let quantityPrecision = 13 - response.ProductQuantityPrecision;
          let maxLimit = "#############";
          let tempMask = "".concat(maxLimit.substring(0, quantityPrecision));
          tempMask = tempMask.concat(".");
          tempMask = tempMask.concat(
            tempMask.substring(0, response.ProductQuantityPrecision)
          );
          this.mask = tempMask;
          this.unitPricePrecision = response.UnitPricePrecision;
          this.productQuantityPrecision = response.ProductQuantityPrecision;
        })
        .catch((error) => {
          helpers.log(error);
        });
    },
    getBankCodes() {
      dataService.GetBankCodes().then((codes) => {
        codes.forEach((c) => {
          c.BankName = c.Code + " - " + c.BankName;
        });
        this.bankCodes = codes;
      });
    },
    editItemInternal(item, bookingItems, n, showDialog, retry) {
      var that = this;
      this.isLoading = showDialog;
      if (n < bookingItems.length) {
        var element = bookingItems[n];
        if (!element.Price) element.Price = 0;
        if (!element.Quantity) element.Quantity = 0;
        element.Price = Number(element.Price).toFixed(this.unitPricePrecision);
        element.Quantity = Number(element.Quantity).toFixed(
          this.productQuantityPrecision
        );
        element.TotalPrice = Number(element.Quantity).toFixed(2);
        if (element.OnHand) element.OnHand = this.formatPrice(element.OnHand);
        that.getLocations(element, element.ProductId, (element, locs) => {
          element.LocationsOnItem = locs;
          dataService.getBookingItemLocation(
            item.BookingId,
            element.BookingItemId,
            element,
            (element, loc) => {
              if (loc) {
                element.savedLocation = loc;
              } else {
                element.savedLocation = item.Location;
              }
              if (n == bookingItems.length - 1) {
                this.isLoading = false;
              }
              that.editItemInternal(
                item,
                bookingItems,
                n + 1,
                showDialog,
                retry
              );
            },
            (error) => {
              helpers.log(error);
            }
          );
        });
      } else {
        item.products = bookingItems;
        item.StartDate = item.StartDate; //this.formatDate(item.StartDate, "MM/DD/YYYY");
        item.EndDate = item.EndDate;//this.formatDate(item.EndDate, "MM/DD/YYYY");
        that.editedItem = Object.assign({}, item);
        that.detaildialog = showDialog;
        if (showDialog == false) {
          // Handling if startdate is older
          this.saveAndApprove(item, retry);
        } else {
          this.isLoading = false;
        }
        helpers.log(item);
      }
    },
    close() {
      this.detaildialog = false;
       setTimeout(() => {
      //   this.$nextTick(() => {
         this.editedItem = Object.assign({}, this.defaultItem);
         this.editedIndex = -1;
      //   this.getDataFromServer();
      // })
       }, 300);
    },
    cancelDecline() {
      this.dialogDeclineComments = false;
    },
    done(email) {
      this.actioninProgress = true;
      email = email.replace("@", "_");
      var userInfo = this.$store.getters.getUserInfo;
      dataService.doneRequest(
        this.editedItem.ReviewRequestId,
        userInfo.userEmail,
        this.editedItem.comments,

        (data) => {
          if (!data) {
            this.actioninProgress = false;
            this.errorOrsuccessMessage = "Error occured";
            this.dialogSuccess = true;
          } else {
            dataService.sendMessage(
              email,
              "Request Notification",
              "Your request has been completed.",
              this.editedItem.AgrisNameAddressID,
              this.editedItem.SQLID
            );
            this.actioninProgress = false;
            this.initialize();
            this.errorOrsuccessMessage = "Request accepted successfully.";
            this.dialogSuccess = true;
            this.close();
          }
        }
      );
    },
    decline(email) {
      this.dialogDeclineComments = true;
    },
    confirmDecline(email) {
      this.cancelDecline();
      this.actioninProgress = true;
      email = email.replace("@", "_");
      var userInfo = this.$store.getters.getUserInfo;
      var agentInfo = JSON.parse(localStorage.agentInfo);

      let IsSameNumber =
        localStorage.getItem("isSameNumber") === "true" ? true : false;
      let IsProUser =
        cryptoService.dencryptString(localStorage.getItem("ProUser")) === "true"
          ? true
          : false;

      var request = {
        Id: booking.BookingId,
        User: userInfo.userEmail,
        Password: userInfo.Password,
        AgrisSession: userInfo.AgrisSessionId,
        SessionId: agentInfo.SessionID,
        TenantId: agentInfo.TenantId,
        BankCode: booking.BankCode,
        TransactionType: booking.TransactionType,
        pendingAgreementSettingStatus: this.pendingAgreementSettingStatus,
        isSameNumber: IsProUser == true && IsSameNumber == true,
      };
      dataService.declineTransaction(request, (data) => {
        if (!data) {
          this.actioninProgress = false;
          this.errorOrsuccessMessage = "Error occured";
          this.dialogSuccess = true;
        } else {
          dataService.sendMessage(
            email,
            "Request Notifcation",
            "Unfortunately, your request has been ,.",
            this.editedItem.AgrisNameAddressID,
            this.editedItem.SQLID
          );
          this.actioninProgress = false;
          this.initialize();
          this.errorOrsuccessMessage = "Request declined successfully.";
          this.dialogSuccess = true;
          this.close();
        }
      });
    },

    async saveBooking(editedItem) {
      // this.isLoading = true;
      //var booking = this.bookings.filter(x=>x.BookingId == editedItem.BookingId)[0];
      //this.updateDatatableWithMessage(booking,0, "Updating...");

      if (!this.validateDates(editedItem)) return;

      let quantityLimitCheck = !!editedItem.products.filter(
        (x) => x.Quantity > 9999999999
      ).length;
      if (quantityLimitCheck) return;

      let priceLimitCheck = !!editedItem.products.filter(
        (x) => x.Price > 9999999999
      ).length;
      if (priceLimitCheck) return;

      var list = [];
      let totalPrice = 0;
      editedItem.products.forEach((element) => {
        var itemLocation = [
          {
            Location: element.selectedLocation
              ? element.selectedLocation
              : element.savedLocation,
          },
        ];
        let startDate = new Date(element.StartDate);
        let endDate = new Date(element.EndDate);
        totalPrice += (element.Price * element.Quantity);
        list.push({
          BookingId: editedItem.BookingId,
          BookingItemId: element.BookingItemId,
          Quantity: element.Quantity,
          Price: element.Price,
          StartDate: startDate,
          EndDate: endDate,
          Remarks: editedItem.Remarks,
          CheckDate: editedItem.StartDate,
          Location: editedItem.Location,
          ItemCurrentLocation: element.selectedLocation
            ? element.selectedLocation
            : element.savedLocation,
          ItemLocation: itemLocation,
          BankCode: editedItem.BankCode ? editedItem.BankCode : "",
          PickupDelivery: editedItem.PickupDelivery,
          OrderStatus: editedItem.OrderStatus,
          OrderField1: editedItem.OrderField1,
          OrderField2: editedItem.OrderField2,
          OrderField3: editedItem.OrderField3,
          IsAlert: editedItem.IsAlert,
          IsPriceOveridden:
            element.Price != element.OriginalPrice &&
            element.Price < element.MinimumPrice,
        });
      });

      //await requestHelper.refreshAgrisLicenseCounter();
      let bookingId = editedItem.BookingId;
      dataService.updateBooking(
        list,
        (response) => {
          this.detaildialog = false;
          let mainBooking = this.bookings.filter(x => x.BookingId == bookingId)[0];
          let itemIndex = this.bookings.indexOf(mainBooking)
          let fn = this.formatPrice(Number(totalPrice));
         // this.$set(this.bookings[itemIndex], 'TotalPrice', fn)
         this.bookings[itemIndex]['TotalPrice']=fn; 
         //this.getDataFromServer();
          // if(showDialog) {
          //   this.snackbarText = "Booking update successfully.";
          //   this.snackbar = true;
          //   this.getDataFromServer();
          // }
        },
        (error) => {
          this.detaildialog = false;
     
          // if (showDialog) {
            this.isLoading = false;
            this.snackbarText = "Booking update failed.";
            this.snackbar = true;
         // }
        }
      );
      this.close();
    },
    validateDates(bookingModel) {
      var errorMessageArray = [];
      bookingModel.products.forEach((element) => {
        let hasError = false;
        let currentObjBegDate = new Date(element.StartDate);
        let currentObjEndDate = new Date(element.EndDate);
        let errorMessage = `=> Item: ${element.ProductId}`;
        if (currentObjEndDate <= currentObjBegDate) {
          hasError = true;
        }
        if (hasError) errorMessageArray.push(errorMessage);
      });
      if (errorMessageArray.length > 0) {
        this.errorDialog = true;
        this.errorDialogText = `Following items have invalid dates:<br/> ${errorMessageArray.join(
          "<br/>"
        )}`;
        return false;
      }
      return true;
    },
    approveBooking(bookingModel, retry = false, isFromModel = false) {
      if (isFromModel) {
        var booking = this.bookings.filter(
          (x) => x.BookingId == bookingModel.BookingId
        )[0];
        //if(!this.validateDates(booking)) return;
        this.detaildialog = false;
        var list = [];
        booking.products.forEach((element) => {
          var itemLocation = [
            {
              Location: element.selectedLocation
                ? element.selectedLocation
                : element.savedLocation,
            },
          ];

          list.push({
            BookingId: booking.BookingId,
            BookingItemId: element.BookingItemId,
            Quantity: element.Quantity,
            Price: element.Price,
            StartDate: element.StartDate,
            EndDate: element.EndDate,
            Remarks: booking.Remarks,
            CheckDate: booking.StartDate,
            Location: booking.Location,
            ItemLocation: itemLocation,
            BankCode: booking.BankCode ? booking.BankCode : "",
            PickupDelivery: booking.PickupDelivery,
            OrderStatus: booking.OrderStatus,
            OrderField1: booking.OrderField1,
            OrderField2: booking.OrderField2,
            OrderField3: booking.OrderField3,
            ItemCurrentLocation: element.selectedLocation
              ? element.selectedLocation
              : element.savedLocation,
          });
        });

        this.updateDatatableWithMessage(booking, 0, "Saving transaction...");
        dataService.updateBooking(
          list,
          (response) => {
            this.approveTransaction(booking);
          },
          (error) => {
            // booking.isSelected = false;
            this.isLoading = false;
            this.updateDatatableWithMessage(
              booking,
              2,
              `Transaction has been approved but Print and pending void requests have been failed: Pending Booking # ${booking.OriginalBookingNumber}. You can view the transaction in 'Failed' section.`
            );
            this.updateDatatableWithMessage(
              booking,
              2,
              "Booking update has been failed. Please try again from 'Pending' section."
            );
            // this.snackbar = true;
          }
        );
      } else {
        var booking = bookingModel;
        this.approveTransaction(booking);
        // this.detaildialog = false;
      }

      //  await requestHelper.refreshAgrisLicenseCounter();

      // if(!booking.products) {
      //       dataService.GetBookingItems(
      //       booking.BookingId,
      //       booking.Location,
      //       (bookingItems) => {
      //         booking.products = bookingItems;
      //         this.udpateDatesAndApprove(booking, retry);
      //       });
      // } else {
      //         this.udpateDatesAndApprove(booking, retry);
      // }
    },
    approveTransaction(booking) {
      this.updateDatatableWithMessage(booking, 0, "Processing...");
      var userInfo = JSON.parse(localStorage.usertData);
      var agentInfo = JSON.parse(localStorage.agentInfo);
      let IsSameNumber =
        localStorage.getItem("isSameNumber") === "true" ? true : false;
      let IsProUser =
        cryptoService.dencryptString(localStorage.getItem("ProUser")) === "true"
          ? true
          : false;

      var approveBooking = {
        Id: booking.BookingId,
        User: userInfo.userEmail,
        Password: userInfo.Password,
        AgrisSession: userInfo.AgrisSessionId,
        SessionId: agentInfo.SessionID,
        TenantId: agentInfo.TenantId,
        BankCode: booking.BankCode,
        isSameNumber:
          IsProUser == true &&
            IsSameNumber == true &&
            booking.TransactionType == "Book" &&
            booking.BookingNumber
            ? true
            : false,
        TransactionType: booking.TransactionType,
        pendingAgreementSettingStatus: this.pendingAgreementSettingStatus,
        IsVoidFailed: booking.IsVoidFailed,
        PendingNumber: booking.OriginalBookingNumber,
        Status: "",
      };

      dataService.approveTransaction(approveBooking, async (response) => {
        let failedApprovedbooking = response.FailedTranactions.filter(
          (x) => x.name == "Approvebooking"
        );
        let failedPrint = response.FailedTranactions.filter(
          (x) => x.name == "Print"
        );
        let failedVoidbooking = response.FailedTranactions.filter(
          (x) => x.name == "Voidbooking"
        );
        let exception = response.FailedTranactions.filter(
          (x) => x.name == "Exception"
        );

        if (exception.length > 0) {
          this.updateDatatableWithMessage(
            booking,
            2,
            "Transaction failed with error: " +
            exception[0].error +
            ". You can retry the transaction from 'Pending' section."
          );
        } else if (response.FailedTranactions.length == 0) {
          this.updateDatatableWithMessage(
            booking,
            1,
            "Your Transaction has been completed. You can view the transaction in 'Approved' section."
          );
        } else if (failedApprovedbooking.length > 0) {
          this.updateDatatableWithMessage(
            booking,
            2,
            "Transaction failed with error: " +
            failedApprovedbooking[0].error +
            ". You can view the transaction in 'Failed' section."
          );
        } else if (failedPrint.length > 0 && failedVoidbooking.length == 0) {
          this.updateDatatableWithMessage(
            booking,
            1,
            "Print Failed. Your transtion has been completed. You can view the transaction in 'Approved' section."
          );
        }
        if (failedVoidbooking.length > 0 && failedPrint.length == 0) {
          if (booking.IsVoidFailed)
            this.updateDatatableWithMessage(
              booking,
              2,
              "Transaction failed with error: " +
              failedVoidbooking[0].error +
              "."
            );
          else
            this.updateDatatableWithMessage(
              booking,
              2,
              `Transaction has been approved but the request for pending void has been failed: Pending Booking # ${booking.OriginalBookingNumber}`
            );
        }
        if (failedVoidbooking.length > 0 && failedPrint.length > 0) {
          this.updateDatatableWithMessage(
            booking,
            2,
            `Transaction has been approved but Print and pending void requests have been failed: Pending Booking # ${booking.OriginalBookingNumber}. You can view the transaction in 'Failed' section.`
          );
        }
      });
    },
    udpateDatesAndApprove(booking, retry) {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();

      today = mm + "/" + dd + "/" + yyyy;

      let _today = new Date();
      let tomorrow = new Date(_today.setDate(_today.getDate() + 1));
      let _dd = String(tomorrow.getDate()).padStart(2, "0");
      let _mm = String(tomorrow.getMonth() + 1).padStart(2, "0"); //January is 0!
      let _yyyy = tomorrow.getFullYear();

      tomorrow = _mm + "/" + _dd + "/" + _yyyy;

      booking.products.forEach((item) => {
        let isStartDateOlder =
          new Date(item.StartDate).setHours(0, 0, 0, 0) <
          new Date(today).setHours(0, 0, 0, 0);
        let isSEndDateOlder =
          new Date(item.EndDate).setHours(0, 0, 0, 0) <=
          new Date(today).setHours(0, 0, 0, 0);

        item.StartDate = isStartDateOlder ? today : item.StartDate;
        item.EndDate = isSEndDateOlder ? tomorrow : item.EndDate;
      });

      //let isStartDateOlder = new Date(booking.StartDate) < new Date(today);
      // let isSEndDateOlder = new Date(booking.EndDate) < new Date(today);

      // booking.StartDate =  isStartDateOlder? today :booking.StartDate;
      // booking.EndDate = isSEndDateOlder? today :booking.EndDate;

      if (!booking.products) {
        this.editItem(booking, "", false, retry);
      } else if (booking.products) {
        this.saveAndApprove(booking, retry);
      } else {
        this.postToAgris(booking, retry);
      }
    },
    saveAndApprove(booking, retry) {
      var list = [];
      booking.products.forEach((element) => {
        var itemLocation = [
          {
            Location: element.selectedLocation
              ? element.selectedLocation
              : element.savedLocation,
          },
        ];

        list.push({
          BookingId: booking.BookingId,
          BookingItemId: element.BookingItemId,
          Quantity: element.Quantity,
          Price: element.Price,
          StartDate: element.StartDate,
          EndDate: element.EndDate,
          Remarks: booking.Remarks,
          CheckDate: booking.StartDate,
          Location: booking.Location,
          ItemLocation: itemLocation,
          BankCode: booking.BankCode ? booking.BankCode : "",
          PickupDelivery: booking.PickupDelivery,
          OrderStatus: booking.OrderStatus,
          OrderField1: booking.OrderField1,
          OrderField2: booking.OrderField2,
          OrderField3: booking.OrderField3,
          ItemCurrentLocation: element.selectedLocation
            ? element.selectedLocation
            : element.savedLocation,
        });
      });
      this.updateDatatableWithMessage(booking, 0, "Saving transaction...");
      dataService.updateBooking(
        list,
        (response) => {
          this.postToAgris(booking, retry);
        },
        (error) => {
          // booking.isSelected = false;
          this.isLoading = false;
          this.updateDatatableWithMessage(booking, 2, "Booking update failed.");
          // this.snackbar = true;
        }
      );
    },
    postToAgris(booking, retry) {
      var userInfo = JSON.parse(localStorage.usertData);
      var agentInfo = JSON.parse(localStorage.agentInfo);
      // this.isLoading = true;

      let IsSameNumber =
        localStorage.getItem("isSameNumber") === "true" ? true : false;
      let IsProUser =
        cryptoService.dencryptString(localStorage.getItem("ProUser")) === "true"
          ? true
          : false;

      var approveBooking = {
        Id: booking.BookingId,
        User: userInfo.userEmail,
        Password: userInfo.Password,
        AgrisSession: userInfo.AgrisSessionId,
        SessionId: agentInfo.SessionID,
        TenantId: agentInfo.TenantId,
        BankCode: booking.BankCode,
        isSameNumber:
          IsProUser == true &&
            IsSameNumber == true &&
            booking.TransactionType == "Book" &&
            booking.BookingNumber &&
            this.pendingAgreementSettingStatus
            ? true
            : false,
      };
      let type = booking.TransactionType == "Book" ? "BKG" : "PMT";
      let self = this;
      this.updateDatatableWithMessage(booking, 0, "Processing..");
      // dataService
      //   .getAgrisDateRange(type)
      //   .then((data) => {
      //     if (data) {
      //       let startDate = new Date(
      //         data.EarliestDateAllowed.split("T")[0] + "T00:00:00"
      //       );
      //       let endDate = new Date(data.LatestDateAllowed);
      //       if (startDate <= new Date(booking.products[0].StartDate)) {
      if (
        this.pendingAgreementSettingStatus == true &&
        booking.TransactionType != "Order"
      ) {
        if (retry == true) {
          if (self.id == "pending") {
            if (booking.Error && !booking.IsVoidFailed)
              this.marKApproveBooking(approveBooking, booking);
            else if (booking.IsVoidFailed) {
              this.retryFailedVoidBooking(approveBooking, booking);
              this.isLoading = false;
            } else if (booking.PrintFailedError) {
              let reload = true;
              let closeModal = true;
              let loading = true;
              this.printApprovedBooking(
                booking,
                approveBooking,
                reload,
                closeModal,
                loading
              );
            }
          } else if (self.id == "approved") {
            if (booking.PrintFailedError && !booking.IsVoidFailed) {
              let reload = true;
              let closeModal = true;
              let loading = true;
              this.printApprovedBooking(
                booking,
                approveBooking,
                reload,
                closeModal,
                loading
              );
            } else if (booking.IsVoidFailed) {
              this.retryFailedVoidBooking(approveBooking, booking);
            } else self.isLoading = false;
            // else if (booking.Error)
            //   this.marKApproveBooking(approveBooking, booking);
          }
        } else {
          this.markApproveBookingWithVoidStatus(approveBooking, booking);
        }
      } else {
        this.marKApproveBooking(approveBooking, booking);
      }
      // } else {
      //   booking.isSelected = false;
      //   this.isLoading = false;
      //   this.dateDialog = true;
      // }
      // }
      // else {
      //   let tags = new SentryTag(
      //     booking.BookingId,
      //     booking.BillToCustomerDescription,
      //     booking.Status,
      //     booking.TransactionType,
      //     booking.StartDate,
      //     booking.EndDate,
      //     booking.Error,
      //     booking.message,
      //   );

      //   sentryService.logException("the function getAgrisDateRange has empty response","PostToAgris",tags);
      //   this.isLoading = false;
      //   this.updateDatatableWithMessage(booking,2, "Transaction failed, error: Something went wrong while getting the dates from Agris");
      //     // this.showAlert(
      //     //   AlertTypes.Error,
      //     //   booking.TransactionType,
      //     //   "Something went wrong while getting the dates from Agris"
      //     // );
      // }
      // }).catch((error) => {
      //   this.isLoading = false;
      //   this.updateDatatableWithMessage(booking,2, "Transaction failed, error: "+error);
      // });
    },
    async marKApproveBooking(approveBooking, booking, isFromDecline = false) {
      await requestHelper.refreshAgrisLicenseCounter();
      this.updateDatatableWithMessage(booking, 0, "Processing Transaction...");
      dataService.approveBooking(
        approveBooking,
        async (response) => {
          if (approveBooking.Status !== "V") {
            this.updateDatatableWithMessage(
              booking,
              0,
              "Booking Approved and printing."
            );
          } else if (approveBooking.Status == "V") {
            approveBooking.Status = "";
            if (isFromDecline) {
              dataService.declineBooking(
                approveBooking,
                (responseDecline) => {
                  if (
                    response &&
                    response.TransactionMessage &&
                    response.TransactionMessage.toLowerCase() ==
                    "already approved"
                  )
                    this.updateDatatableWithMessage(
                      booking,
                      2,
                      "Transaction failed, error: " +
                      response.TransactionMessage
                    );
                  else
                    this.updateDatatableWithMessage(
                      booking,
                      2,
                      "Transaction declined."
                    );
                },
                (error) => {
                  helpers.log(error);
                  this.isLoading = false;
                  this.updateDatatableWithMessage(
                    booking,
                    2,
                    "Transaction failed, error: " + error
                  );
                }
              );
            }
          }
          if (response.TransactionObject && !isFromDecline) {
            this.isLoading = false;
            try {
              if (response.TransactionMessage != "Failed") {
                if (approveBooking.Status !== "V") {
                  dataService
                    .printTransaction(approveBooking)
                    .then((data) => {
                      // if(showDialog) {
                      //         this.showAlert(
                      //         AlertTypes.Approve,
                      //         booking.TransactionType,a
                      //         response.TransactionMessage
                      //       );
                      // } else {
                      this.updateDatatableWithMessage(
                        booking,
                        1,
                        "Your Transaction has been completed. You can view the transaction in Approved section."
                      );
                      // }
                      helpers.log("print successful");
                      helpers.log(data);
                    })
                    .catch((error) => {
                      this.updateDatatableWithMessage(
                        booking,
                        2,
                        "Print Failed. Your transtion has been completed. You can view the transaction in Approved section."
                      );
                      helpers.log("print failed");
                      helpers.log(error);
                    });
                }
              } else {
                if (approveBooking.Status !== "V")
                  // if(showDialog)
                  //     this.showAlert(AlertTypes.Error, booking.TransactionType);
                  // else {
                  this.updateDatatableWithMessage(
                    booking,
                    2,
                    "Transaction failed, error: " +
                    response.ErrorMessage +
                    ". You can view the transaction in Failed section."
                  );
              }
              // }
              // booking.message = "Booking Approved with traction number : "+response.TransactionMessage;
              //this.getDataFromServer();
            } catch (ex) {
              helpers.error(ex);
            }
          } else if (!isFromDecline) {
            this.isLoading = false;
            // this.showAlert(AlertTypes.Error, booking.TransactionType);
            this.updateDatatableWithMessage(
              booking,
              2,
              "Transaction failed, error: " +
              response.ErrorMessage +
              ". You can view the transaction in Failed section."
            );
          }
        },
        (error) => {
          helpers.log(error);
          this.isLoading = false;
          this.updateDatatableWithMessage(
            booking,
            2,
            "Transaction failed, error: " +
            error.ErrorMessage +
            ". You can view the transaction in Failed section."
          );
          // this.showAlert(AlertTypes.Error, booking.TransactionType);
        }
      );
    },
    async markApproveBookingWithVoidStatus(approveBooking, booking) {
      try {
        if (!booking.IsVoidFailed) {
          await requestHelper.refreshAgrisLicenseCounter();
          approveBooking.Status = "";

          let responseWithEmptyStatus =
            await dataService.markVoidAndApproveBooking(approveBooking);
          this.updateDatatableWithMessage(
            booking,
            0,
            "Processing Transaction..."
          );
          if (
            responseWithEmptyStatus.TransactionMessage.toLowerCase() ==
            "approved"
          ) {
            this.updateDatatableWithMessage(
              booking,
              0,
              "Booking Approved and printing."
            );

            await this.printApprovedBooking(booking, approveBooking);
            if (approveBooking.isSameNumber) {
              this.updateDatatableWithMessage(
                booking,
                1,
                "Your Transaction has been completed. You can view the transaction in Approved section."
              );
              return;
            }
            approveBooking.Status = "V";
            let responseVoid = await dataService.markVoidAndApproveBooking(
              approveBooking
            );
            if (responseVoid.TransactionObject) {
              if (
                responseVoid.TransactionMessage.toLowerCase() != "failed" &&
                responseVoid.TransactionMessage.toLowerCase() != "duplicate"
              ) {
                this.updateDatatableWithMessage(
                  booking,
                  1,
                  "Your Transaction has been completed. You can view the transaction in Approved section."
                );
              } else if (
                responseVoid.TransactionMessage.toLowerCase() ==
                "there is no pending transaction to void."
              ) {
                this.updateDatatableWithMessage(
                  booking,
                  1,
                  "Your Transaction has been completed. You can view the transaction in Approved section."
                );
              } else {
                this.updateDatatableWithMessage(
                  booking,
                  2,
                  `Transaction has been approved but the request for pending void has been failed: Pending Booking # ${booking.OriginalBookingNumber}`
                );
              }
            } else {
              this.updateDatatableWithMessage(
                booking,
                2,
                "Transaction failed, error: " + responseVoid.ErrorMessage
              );
            }
          } else if (
            responseWithEmptyStatus.TransactionMessage.toLowerCase() !=
            "already approved" ||
            responseWithEmptyStatus.TransactionMessage.toLowerCase() !=
            "already declined"
          ) {
            this.updateDatatableWithMessage(
              booking,
              2,
              "Transaction failed, error: " +
              responseWithEmptyStatus.TransactionMessage
            );
          } else {
            this.updateDatatableWithMessage(
              booking,
              2,
              "Transaction failed, error: " +
              responseWithEmptyStatus.ErrorMessage +
              ". You can view the transaction in Failed section."
            );
          }
        } else {
          this.retryFailedVoidBooking(approveBooking, booking);
        }
        // this.close();
      } catch (ex) {
        this.isLoading = false;
        // booking.isSelected = false;
        this.updateDatatableWithMessage(
          booking,
          2,
          "Transaction failed with error: " +
          ex +
          ". You can view the transaction in Failed section."
        );
        SentryService.logMessage(ex);
        // this.showAlert(AlertTypes.Error, booking.TransactionType);
      }
    },
    async retryFailedVoidBooking(approveBooking, booking) {
      approveBooking.Status = "V";
      let responseVoid = await dataService.markVoidAndApproveBooking(
        approveBooking
      );
      if (responseVoid.TransactionObject) {
        if (
          responseVoid.TransactionMessage.toLowerCase() != "failed" &&
          responseVoid.TransactionMessage.toLowerCase() != "duplicate"
        ) {
          this.updateDatatableWithMessage(
            booking,
            1,
            "Your Transaction has been completed. You can view the transaction in Approved section."
          );
        } else {
          this.checkBookingStatus(booking).then((alreadyVoided) => {
            if (alreadyVoided) {
              this.updateDatatableWithMessage(
                booking,
                1,
                "Your Transaction has been completed. You can view the transaction in Approved section."
              );
            } else
              this.updateDatatableWithMessage(
                booking,
                2,
                "Transaction failed, error: " +
                  responseVoid.TransactionMessage.toLowerCase() ==
                  "duplicate"
                  ? responseVoid.ErrorMessage
                  : "Void Failed"
              );
          });
        }
      } else {
        this.checkBookingStatus(booking).then((alreadyVoided) => {
          if (alreadyVoided) {
            this.updateDatatableWithMessage(
              booking,
              1,
              "Your Transaction has been completed. You can view the transaction in Approved section."
            );
          } else
            this.updateDatatableWithMessage(
              booking,
              2,
              "Transaction failed, error: " + responseVoid.ErrorMessage
            );
        });
      }
    },
    checkBookingStatus(booking) {
      return new Promise((resolve) => {
        let bookingNumber = booking.OriginalBookingNumber.split("-")[1];
        dataService
          .getBooking(bookingNumber)
          .then((res) => {
            if (res[0].Status == "V") {
              dataService
                .changeVoidBookingStatus(booking.BookingId, false)
                .then((res1) => {
                  resolve(res1 && res1.TransactionObject);
                })
                .catch((e) => {
                  resolve(false);
                });
            } else {
              resolve(false);
            }
          })
          .catch((e) => {
            resolve(false);
          });
      });
    },
    async printApprovedBooking(
      booking,
      approveBooking,
      reload = false,
      closeModal = false,
      loading = false
    ) {
      try {
        this.updateDatatableWithMessage(booking, 0, "Printing..");
        //await requestHelper.refreshAgrisLicenseCounter();
        // if (loading == true) this.isLoading = true;

        let printResponse = await dataService.printTransaction(approveBooking);
        if (loading == true) this.isLoading = false;
        if (printResponse.ErrorMessage) {
          this.updateDatatableWithMessage(
            booking,
            2,
            "Print failed. Error:" + printResponse.ErrorMessage
          );
          // this.snackbarText = "Print failed.";
          // this.snackbar = true;
          return;
        }
        this.updateDatatableWithMessage(booking, 0, "Print Successfull.");
        // if (closeModal) this.close();
        // if (reload) this.getDataFromServer();

        return printResponse;
      } catch (ex) {
        this.isLoading = false;
        // this.snackbarText = "Print failed.";
        // this.snackbar = true;
        return null;
      }
    },
    declineBooking(bookingModel, isFromModel = false) {
      if (isFromModel)
        var booking = this.bookings.filter(
          (x) => x.BookingId == bookingModel.BookingId
        )[0];
      else var booking = bookingModel;
      this.$confirm({
        message: "Are you sure you want to decline this booking?",
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            if (isFromModel) this.detaildialog = false;
            this.updateDatatableWithMessage(booking, 0, "Processing decline..");
            await requestHelper.refreshAgrisLicenseCounter();
            var userInfo = JSON.parse(localStorage.usertData);
            var agentInfo = JSON.parse(localStorage.agentInfo);

            let IsSameNumber =
              localStorage.getItem("isSameNumber") === "true" ? true : false;
            let IsProUser =
              cryptoService.dencryptString(localStorage.getItem("ProUser")) ===
                "true"
                ? true
                : false;

            // this.isLoading = true;
            let request = {
              Id: booking.BookingId,
              User: userInfo.userEmail,
              Password: userInfo.Password,
              AgrisSession: userInfo.AgrisSessionId,
              SessionId: agentInfo.SessionID,
              TenantId: agentInfo.TenantId,
              Status: "V",
              isFromDecline: true,
              TransactionType: booking.TransactionType,
              pendingAgreementSettingStatus: this.pendingAgreementSettingStatus,
              isSameNumber: IsProUser == true && IsSameNumber == true,
              PendingNumber: booking.OriginalBookingNumber,
            };
            dataService.declineTransaction(
              request,
              (response) => {
                let failedVoidbooking = response.FailedTranactions.filter(
                  (x) => x.name == "Voidbooking"
                );
                let failedSetBookingStatusToRejected =
                  response.FailedTranactions.filter(
                    (x) => x.name == "SetBookingStatusToRejected"
                  );
                let exception = response.FailedTranactions.filter(
                  (x) => x.name == "Exception"
                );

                if (exception.length > 0) {
                  this.updateDatatableWithMessage(
                    booking,
                    2,
                    "Transaction failed with error: " +
                    exception[0].error +
                    ". You can retry the transaction from 'Pending' section."
                  );
                } else if (response.FailedTranactions.length == 0) {
                  this.updateDatatableWithMessage(
                    booking,
                    2,
                    "Your Transaction has been declined. You can view the transaction in 'Declined' section."
                  );
                } else if (failedVoidbooking.length > 0) {
                  // this.updateDatatableWithMessage(booking, 2, `The request for pending void has been failed: error: ${failedVoidbooking[0].error} Pending Booking # ${booking.OriginalBookingNumber}`);
                  this.updateDatatableWithMessage(
                    booking,
                    2,
                    `The request for pending void has been failed: Pending Booking # ${booking.OriginalBookingNumber}`
                  );
                  // this.updateDatatableWithMessage(booking,2, "Transaction failed with error: " +failedVoidbooking[0].error+ ". You can view the transaction in 'Failed' section.")
                } else if (failedSetBookingStatusToRejected.length > 0) {
                  this.updateDatatableWithMessage(
                    booking,
                    2,
                    "Transaction failed with error: " +
                    failedSetBookingStatusToRejected[0].error +
                    ". You can view the transaction in 'Failed' section."
                  );
                }
              },
              (error) => {
                helpers.log(error);
                this.isLoading = false;
                this.updateDatatableWithMessage(
                  booking,
                  2,
                  "Transaction failed, error: " + error
                );
              }
            );
            // if (this.pendingAgreementSettingStatus == true) {
            //   this.marKApproveBooking(approveBooking, booking, true);
            // } else {
            //    dataService.declineBooking(
            //     approveBooking,
            //     (response) => {
            //         this.updateDatatableWithMessage(booking,2, "Transaction declined.");
            //       },
            //     (error) => {
            //       helpers.log(error);
            //       this.isLoading = false;
            //       this.updateDatatableWithMessage(booking, 2, "Transaction failed, error: "+error);
            //     });
            //   // this.updateDatatableWithMessage(booking, 2,  'Transaction Declined..');
            // }
          } else {
            this.isLoading = false;
            // this.updateDatatableWithMessage(booking, 2, "Transaction failed, error: "+response.ErrorMessage);
          }
        },
      });
    },
    formatDate(value, dateFormat = "MM/DD/YYYY") {
      if (value) {
        return moment(String(value)).format(dateFormat);
      }
    },
    formatDateTime(value) {
      if (value) {
        var date = moment.utc(value).format('YYYY-MM-DD hh:mm A');
        var stillUtc = moment.utc(date).toDate();
        var local = moment(stillUtc).local().format('YYYY-MM-DD hh:mm A');
        return local;
        //var testdate = new Date();


       /// let date = moment.utc(value).local();
      //  return   date.format("MM/DD/YYYY hh:mm A");
      }
    },
    bookingTimestampDateTime(newdate) 
    {
      
      //let  newdate = new Date(date);
      const year = newdate.getFullYear();
      const month = ('0' + (newdate.getMonth() + 1)).slice(-2);
      const day = ('0' + newdate.getDate()).slice(-2);
      let hours = newdate.getHours();
      const minutes = ('0' + newdate.getMinutes()).slice(-2);
      const ampm = hours >= 12 ? 'pm' : 'am';

      hours = hours % 12;
      hours = hours ? hours : 12; // Handle midnight (0 hours)

      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;

      return formattedDate;
    },
    DateFormate(newdate) 
    {
      //let  newdate = new Date(date);
      
      const year = newdate.getFullYear();
      const month = ('0' + (newdate.getMonth() + 1)).slice(-2);
      const day = ('0' + newdate.getDate()).slice(-2);
      let hours = newdate.getHours();
      const minutes = ('0' + newdate.getMinutes()).slice(-2);
      const ampm = hours >= 12 ? 'pm' : 'am';

      hours = hours % 12;
      hours = hours ? hours : 12; // Handle midnight (0 hours)
    
       const formattedDate = `${year}-${month}-${day}`;
    

      return formattedDate;
    },

    getMinEndDate(value) {
      return moment(value).add(1, "Days").format("YYYY-MM-DD").toString();
    },


    filterChange() {      
      

      this.showExpiredQuotes  =  this.showExpiredQuotes === true ? true : false;
      this.showDeletedQuotes = this.showExpiredQuotes === true ? true : false;
      this. getDataFromServer();
    },

    getDataFromServer(options) {

      if (options) {
        this.pagination.page = options.page;
        this.pagination.rowsPerPage = options.itemsPerPage;
        if (options.sortBy && options.sortBy.length) {
          this.sortBy = options.sortBy;
        }
      }

      this._loading = true;
      this.isLoading = true;
      dataService.ValidateAgentSession().finally(() => {
        const { page, rowsPerPage } = this.pagination;
        const sortField = this.sortBy && this.sortBy.length ? this.sortBy[0].key : "BookingTimestamp";
        const descending = this.sortBy && this.sortBy.length && this.sortBy[0].order === "desc";
        this.getAgentVersion();
          this.getAgrisDecimalPrecision();
          this.getBankCodes();
          this.getOrderData();

          let usertData = JSON.parse(localStorage.usertData);

          if(usertData && usertData.Permission){
            let permissions = usertData.Permission.filter(
              (x) => x.Package == "INV" && x.SecurityOption == "PIMPT"
            );
            this.isOrderPermission =
              permissions.length > 0
                ? parseInt(permissions[0].SecurityLevel) > 1
                : false;
            dataService.GetPendingBookingsPaginated(
              this.$props.id,
              this.showExpiredQuotes,
              this.showDeletedQuotes,
              page,
              rowsPerPage,
              sortField,
              descending ? "DESC" : "ASC",
              this.appliedColumnFilters,
              (_bookings, totalRecords) => {
                // this.resetSearchedText();
                _bookings.forEach((item) => {
                  item.CreditAvailable = this.formatPrice(item.CreditAvailable);
                  item.ControlStartDateMenu = false;
                  item.ControlEndDateMenu = false;
                  item.ControlStartDate = this.formatDate(
                    item.StartDate,
                    "YYYY-MM-DD"
                  );
                  item.ControlEndDate = this.formatDate(
                    item.EndDate,
                    "YYYY-MM-DD"
                  );
                  item.CheckDate = this.formatDate(item.CheckDate);
                  // item.ApproveTimestamp = this.formatDate(
                  //   item.ApproveTimestamp,
                  //   "YYYY-MM-DD hh:mm A"
                  // );
                  item.IsExpired = new Date(item.ExpiryDate) < new Date();
                  item.StartDate = new Date(item.StartDate);  //this.formatDate(item.StartDate, "MM/DD/YYYY");
                  item.EndDate = new Date(item.EndDate); //this.formatDate(item.EndDate, "MM/DD/YYYY");
                  item.BookingTimestamp =  new Date(item.BookingTimestamp); //moment(item.BookingTimestamp); //this.formatDateTime(item.BookingTimestamp);
                  item.ExpiryDate = new Date(item.ExpiryDate);
                  item.DeletedTimeStamp = this.formatDateTime(item.DeletedTimeStamp);
                  if (this.id == "declined") {
                    item.ApproveTimestamp = item.ApproveTimestamp
                      ? this.formatDateTime(item.ApproveTimestamp)
                      : "";
                  } else {
                    item.ApproveTimestamp = item.ApproveTimestamp
                      ? this.formatDate(item.ApproveTimestamp)
                      : "";
                  }
                  item.TotalPrice = this.formatPrice(item.TotalPrice);
                  if (item.CheckAmount)
                    item.CheckAmount = this.formatPrice(item.CheckAmount);

                  if (!item.TransactionType) {
                    item.TransactionType = "Book";
                  }
                  if (item.PickupDelivery) {
                    item.PickupDelivery = item.PickupDelivery.trim();
                  }

                  item.showErrorDetails = false;
                });
                this.bookings = _bookings;
                // console.log(this.bookings);
                this.originalBookings = _bookings;
                // this.$store.commit("updateBookings", this.bookings);
                this.totalBookings = totalRecords;

                this.isLoading = false;
                setTimeout(() => {
                  this._loading = false;
                }, 1000);
              },
              (error) => {
                this.isLoading = false;
                this.bookings = [];
                this.originalBookings = [];
              }
            );
          }
      });
    },
    getLocations(item, productIds, callback) {
      dataService.getLocations(
        productIds,
        (locations) => {
          this.locations = locations;
          this.locations.forEach((location) => {
            location.Description = location.Code + " - " + location.Description;
          });
          callback(item, locations);
        },
        () => { }
      );
    },
    getOrderData() {
      this.orderStatuses = [];
      this.orderStatuses.push({ id: "A", value: "Active" });
      dataService.GetPackageSetupToken("INV").then((data) => {
        this.getOrderStatus(Object.create(data));
        this.getOrderFields(Object.create(data));
      });
    },
    getOrderStatus(data) {
      data
        .filter((d) => d.SetupToken.includes("ORDER_PENDING_REASON"))
        .forEach((status, i) => {
          let count = i + 1;
          if (status.SetupToken.includes(count)) {
            this.orderStatuses.push({
              id: count.toString(),
              value: status.SetupValue,
            });
          }
        });
    },
    getOrderFields(data) {
      this.orderField1Required = false;
      this.orderField2Required = false;
      this.orderField3Required = false;

      this.orderField1Label = data.filter((d) =>
        d.SetupToken.includes("ORDER_FIELD1_LABEL")
      )[0].SetupValue;
      this.orderField2Label = data.filter((d) =>
        d.SetupToken.includes("ORDER_FIELD2_LABEL")
      )[0].SetupValue;
      this.orderField3Label = data.filter((d) =>
        d.SetupToken.includes("ORDER_LINE_FIELD_LABEL")
      )[0].SetupValue;

      let feild1 = data.filter((d) =>
        d.SetupToken.includes("REQUIRE_ORDER_FIELD1")
      )[0].SetupValue;
      let feild2 = data.filter((d) =>
        d.SetupToken.includes("REQUIRE_ORDER_FIELD2")
      )[0].SetupValue;
      let feild3 = data.filter((d) =>
        d.SetupToken.includes("REQUIRE_ORDER_FIELD3")
      )[0].SetupValue;

      if (feild1 == "1" || feild1 == "3") {
        this.orderField1Label = this.orderField1Label + " *";
        this.orderField1Required = true;
      }
      if (feild2 == "1" || feild2 == "3") {
        this.orderField2Label = this.orderField2Label + " *";
        this.orderField2Required = true;
      }
      if (feild3 == "1" || feild3 == "3") {
        this.orderField3Label = this.orderField3Label + " *";
        this.orderField3Required = true;
      }
    },
    getVariancePriceLevel(Price, PriceLevel) {
      var percentage = 0;
      if (Price == 0 || PriceLevel == 0 || Price == PriceLevel) {
        percentage = 0;
      } else {
        percentage = Price / (PriceLevel / 100) - 100.0;
      }
      return Number(percentage).toFixed(2) + "%";
    },
    calculateTotalAmount(Quantity, Price) {
      if (this.showDialog) {
        if (!Quantity) Quantity = 0;
        if (!Price) Price = 0;
        let total = Quantity * Price;
        return this.formatPrice(Number(total));
      }
    },
    showWarning(editedItem) {
      if (editedItem.CreditAvailable && editedItem.TotalPrice) {
        
        let available = parseFloat(
          //editedItem.CreditAvailable.replace(/,/g, "")
          editedItem.CreditAvailable
        );
        // let total = parseFloat(editedItem.TotalPrice.replace(/,/g, ""));
        let total = parseFloat(editedItem.TotalPrice);
        if (available < 0) return true;
        if (available == 0) return false;
        return available < total;
      }
    },
    searhResult(text, _searchedText, column) {
      // update header filter state
      this.headers.forEach((x) => {
        if (x.value == column) {
          x.isSearched = !!text;
          x.searchedText = text;
        }
      });

      // client-side filtering disabled — column filters are applied server-side via Apply Filters (ASR-11)
      // this.bookings = this.originalBookings;
      // this.headers.forEach((header) => {
      //   if (header.isSearched) {
      //     this.bookings = this.bookings.filter((x) => {
      //       var val = x[header.value] ? x[header.value].toString() : x[header.value];
      //       if (header.value == "StartDate" || header.value == "EndDate" || header.value == "ExpiryDate") {
      //         val = this.DateFormate(new Date(val));
      //       } else if (header.value == "BookingTimestamp") {
      //         val = this.bookingTimestampDateTime(new Date(val));
      //       } else if (header.value == "CreditAvailable" || header.value == "TotalPrice") {
      //         val = val;
      //       }
      //       if (val) {
      //         var isMatched = val.toLowerCase().indexOf(header.searchedText.toLowerCase()) != -1;
      //         if (isMatched) {
      //           return x;
      //         }
      //       }
      //     });
      //   }
      // });

      // clearing an applied box drops its filter; with none left the original grid comes back
      if (!(text && text.trim()) && column in this.appliedColumnFilters) {
        const remaining = { ...this.appliedColumnFilters };
        delete remaining[column];
        this.appliedColumnFilters = remaining;
        this.pagination.page = 1;
        this.getDataFromServer();
      }
    },
    applyColumnFilters() {
      const filters = {};
      this.headers.forEach((h) => {
        const value = h.searchedText ? h.searchedText.trim() : "";
        if (value) filters[h.value] = value;
      });
      this.appliedColumnFilters = filters;
      this.pagination.page = 1;
      this.getDataFromServer();
    },
    quickFilterValue(item, column) {
      const val = item[column];
      if (val === null || val === undefined || val === "") return "";
      if (column === "StartDate" || column === "EndDate" || column === "ExpiryDate") {
        return this.DateFormate(new Date(val));
      }
      if (column === "BookingTimestamp") {
        return this.bookingTimestampDateTime(new Date(val));
      }
      return String(val);
    },
    resetSearchedText() {
      this.headers.forEach((header) => {
        header.searchedText = "";
        header.isSearched = false;
      });
    },
    formatPrice(value) {
      //return value .toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return value.toLocaleString("en-US", {style: "currency",currency: "USD" });
    },
    showAlert(alertType, type, transactionMessage, timeout = 6) {
      if (alertType == AlertTypes.Error) {
        this.initAlert();
        this.errorAlert = true;
      } else if (alertType == AlertTypes.Approve) {
        this.initAlert();
        this.approveAlert = true;
      } else if (alertType == AlertTypes.Decline) {
        this.initAlert();
        this.declineAlert = true;
      }

      let msg;
      if (type == TransactionTypes.Book) {
        msg = transactionMessage
          ? `Booking ${transactionMessage}`
          : "Booking Failed";
      } else if (type == TransactionTypes.Prepay) {
        msg = transactionMessage
          ? `Prepay ${transactionMessage}`
          : "Prepay Failed";
      } else if (type == TransactionTypes.Order) {
        msg = transactionMessage
          ? `Order ${transactionMessage}`
          : "Order Failed";
      }
      this.alertText = msg;

      setTimeout(() => {
        this.initAlert();
      }, timeout * 1000);
    },
    initAlert() {
      this.approveAlert = false;
      this.errorAlert = false;
      this.declineAlert = false;
      this.alertText = "";
    },
    async getAppSettings() {
      try {
        let response = await dataService.GetAppSettingsByType(
          AppSettingConfigurations.PendingAgreements
        );
        if (response && response.length) {
          let settingStatus = response.find(
            (x) => x.Name == PendingAgreementConfigurations.Status
          );
          if (settingStatus && settingStatus.Value)
            this.pendingAgreementSettingStatus = JSON.parse(
              settingStatus.Value
            );
          if (this.pendingAgreementSettingStatus == true) {
            let settingBookingStatus = response.find(
              (x) =>
                x.Name == PendingAgreementConfigurations.PendingBookingStatus
            );
            if (settingBookingStatus && settingBookingStatus.Value)
              this.pendingAgreementSettingBookingStatus =
                settingBookingStatus.Value;

            let settingPrepayStatus = response.find(
              (x) =>
                x.Name == PendingAgreementConfigurations.PendingPrepayStatus
            );
            if (settingPrepayStatus && settingPrepayStatus.Value)
              this.pendingAgreementSettingPrepayStatus =
                settingPrepayStatus.Value;
          }

          // helpers.log(
          //   "pendingAgreementSettingStatus =>",
          //   this.pendingAgreementSettingStatus
          // );
          // helpers.log("pendingAgreementSettingBookingStatus =>",this.pendingAgreementSettingBookingStatus);
          // helpers.log("pendingAgreementSettingPrepayStatus =>",this.pendingAgreementSettingPrepayStatus);
        }
      } catch (ex) {
        helpers.log(ex);
      }
    },
    retryBookingOnError(booking) {
      if (booking.Error) {
        if (booking.TransactionType == TransactionTypes.Book) {
          booking.Status = this.pendingAgreementSettingBookingStatus;
        } else if (booking.TransactionType == TransactionTypes.Prepay) {
          booking.Status = this.pendingAgreementSettingPrepayStatus;
        }
      }
      let retry = true;
      this.approveBooking(booking, retry, true);
    },
    getMessage(item) {
      return item.message;
    },
    getColspan(id) {
      switch (id) {
        case "pending":
          return 8;
        case "approved":
          return 7;
        default:
          return 9;
      }
    },
    getCSSClass(isSuccessfull) {
      switch (isSuccessfull) {
        case 1:
          return "row_success";
        case 2:
          return "row_error";
        default:
          return "blink_process";
      }
    },
    updateDatatableWithMessage(booking, status, message) {
      booking.isSuccessfull = status;
      booking.message = message;
      booking.isSelected = true;
      const cloneBooking = Object.assign([], this.bookings);
      this.bookings = [];
      this.bookings = cloneBooking;
    },
    handleColumnHeaderClick(event, column) {
      console.log('Column clicked')
      console.log(event)
      console.log(column)
    },

    toggleSort($event) {
      
      let test = $event;
     if($event.length >0){
        
        const key = $event[0].key
        const order = $event[0].order
        switch (key) {
          case 'BookingTimestamp':
            this.sortBy=[];
            this.sortBy = [
              { key: 'BookingTimestamp', order: order },             
              ];
           
            // return items;



            break;
          }
          let sortedArray = this.bookings; 
          console.log(this.bookings);

          this.bookings.sort((a, b) => {
                if (this.sortBy[0].key=='BookingTimestamp') {
                  if (this.sortBy[0].order == 'asc') {
                      return new Date(b[test[0].key]) - new Date(a[test[0].key]);
                  } else {
                      return new Date(a[test[0].key]) - new Date(b[test[0].key]);
                  }
                }
               else if (this.sortBy[0].key == "EndDate") {
                if (this.sortBy[0].order == 'asc') {
                  return new Date(b[this.sortBy[0].key]) - new Date(a[this.sortBy[0].key]); // entry Date colum sort if desc is true
                } else {
                  return new Date(a[this.sortBy[0].key]) - new Date(b[this.sortBy[0].key]); // entry Date colum sort if desc is false
                }
              } else if (this.sortBy[0].key == "ApproveTimestamp") {
                if (this.sortBy[0].order == 'asc') {
                  return new Date(b[this.sortBy[0].key]) - new Date(a[this.sortBy[0].key]); // entry Date colum sort if desc is true
                } else {
                  return new Date(a[this.sortBy[0].key]) - new Date(b[this.sortBy[0].key]); // entry Date colum sort if desc is false
                }
              }
              else {
                  if(typeof a[this.sortBy[0].key] !== 'undefined'){
                    if (this.sortBy[0].order == 'asc') {
                       return a[this.sortBy[0].key].toLowerCase().localeCompare(b[this.sortBy[0].key].toLowerCase());
                    }
                    else {
                        return b[this.sortBy[0].key].toLowerCase().localeCompare(a[this.sortBy[0].key].toLowerCase());
                    }
                  }
                }
            });
            console.log(this.bookings);
           // this.bookings =sortedArray;
     }else{
      this.sortBy =  [ { key: 'BookingTimestamp', order: 'asc' }];
     }
      return this.bookings;
    },

    customSort($event) {
      
     //console.log(index);
     // console.log(isDesc);
     let test = $event;
     if($event.length >0){
        
        const key = $event[0].key
        const order = $event[0].order
        switch (key) {
          case 'BookingTimestamp':
            this.sortBy=[];
            this.sortBy = [
              { key: 'BookingTimestamp', order: order },             
              ];
           
            // return items;



            break;
          }
          let sortedArray = this.bookings; 
          console.log(this.bookings);

          this.bookings.sort((a, b) => {
                if (this.sortBy[0].key=='BookingTimestamp') {
                  if (this.sortBy[0].order == 'asc') {
                      return new Date(b[test[0].key]) - new Date(a[test[0].key]);
                  } else {
                      return new Date(a[test[0].key]) - new Date(b[test[0].key]);
                  }
                }
               else if (this.sortBy[0].key == "EndDate") {
                if (this.sortBy[0].order == 'asc') {
                  return new Date(b[this.sortBy[0].key]) - new Date(a[this.sortBy[0].key]); // entry Date colum sort if desc is true
                } else {
                  return new Date(a[this.sortBy[0].key]) - new Date(b[this.sortBy[0].key]); // entry Date colum sort if desc is false
                }
              } else if (this.sortBy[0].key == "ApproveTimestamp") {
                if (this.sortBy[0].order == 'asc') {
                  return new Date(b[this.sortBy[0].key]) - new Date(a[this.sortBy[0].key]); // entry Date colum sort if desc is true
                } else {
                  return new Date(a[this.sortBy[0].key]) - new Date(b[this.sortBy[0].key]); // entry Date colum sort if desc is false
                }
              }
              else {
                  if(typeof a[this.sortBy[0].key] !== 'undefined'){
                    if (this.sortBy[0].order == 'asc') {
                       return a[this.sortBy[0].key].toLowerCase().localeCompare(b[this.sortBy[0].key].toLowerCase());
                    }
                    else {
                        return b[this.sortBy[0].key].toLowerCase().localeCompare(a[this.sortBy[0].key].toLowerCase());
                    }
                  }
                }
            });
            console.log(this.bookings);
           // this.bookings =sortedArray;
     }
     else{
      this.sortBy =  [];
     }
     

      
    },
    // toggleSort($event){
    //   

    // },



    DownloadItem(item, id) {
      // this.isLoading = true;
      var bookingID = item.BookingId;
      var isPending = true;

      if (id == "pending") {
        isPending = true;
      } else if (id == "approved") {
        isPending = false;
      }

      dataService
        .DownloadprintTransaction(bookingID, isPending, item.BookingNumber)
        .then((data) => {
          this.isLoading = false;
        })
        .catch((error) => {
          helpers.log("print failed");
          // this.isLoading = false;
          helpers.log(error);
        });
    },
  },
};
</script>

<style>
.theme--light.v-input.search-field input::placeholder {
  color: green;
}


.cell-font-size {
  font-size: 12px;
}

.print-error-message {
  border: 1px solid red;
  margin-top: 15px;
  padding: 10px;
  font-weight: 500;
  background: #fef8f8;
}

.print-error-message p {
  font-size: 14px;
  margin-bottom: 0px;
}

.print-error-badge {
  background: red;
  color: red;
  border-radius: 15px;
  z-index: 2;
  position: relative;
  top: 10px;
  left: 24px;
  width: 10px;
  height: 10px;
}

.alert-badge {
  z-index: 2;
  position: relative;
  top: 10px;
  left: 24px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 16px solid rgb(255, 221, 0);
  color: black;
  text-align: center;
  line-height: 20px;
}

.text-blue-grey-light {
  color: #a5aaae !important;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going 1s;
}

.oranged--text {
  color: orangered;
}

@keyframes going {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

input:disabled {
  color: black;
}

/* 
.v-table>.v-table__wrapper>table {
    border-spacing: 0;
    width: max-content !important;
} */
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 5px;
}

.font_large {
  font-size: xx-large !important;
}

.font_xlarge {
  font-size: x-large;
}

.font_trueSmall {
  font-size: small;
}

.font_small {
  font-size: xx-small;
}

.font_xsmall {
  font-size: x-small;
}

.padding_5_20 {
  padding: 5px 20px;
}

.items_table {
  overflow-y: auto;
  max-height: 400px;
  margin-top: 5px;
}

/* .items_table tr{
  height: 10px !important;
}.items_table td{
  height: 10px !important;
} */

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.padding_left_78percent{
  padding-left: 78% !important;
}

.modal-heading {
  padding-top: 20px;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 20px;
}

.padding_right_5 {
  padding-right: 10px;
}

.tooltip {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 100%;
  background-color: white;
  color: black;
  text-align: center;
  border: 1px solid black;
  /* If you want dots under the hoverable text */
  padding: 5px 0;
  border-radius: 6px;
  bottom: 100%;
  left: 30%;
  margin-left: -60px;
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}

.padding_top_8 {
  padding-top: 8px;
}

.padding_top_12 {
  padding-top: 12px;
}

.blink_error {
  color: #fff;
  /* padding: 10px;
		display: inline-block;
		border-radius: 5px; */
  animation: blinkingBackground 8s infinite;
}

@keyframes blinkingBackground {
  0% {
    background-color: #ad0d0d;
  }

  25% {
    background-color: #9a0000;
  }

  50% {
    background-color: #7e1d1d;
  }

  75% {
    background-color: #9a0000;
  }

  100% {
    background-color: #ad0d0d;
  }
}

.blink_process {
  color: rgb(32, 32, 32);
  /* padding: 10px;
		display: inline-block;
		border-radius: 5px; */
  animation: blinkingBackground 8s infinite;
}

.custom_switch {
  margin-top: 25px;
  margin-left: 10px;
}

@keyframes blinkingBackground {
  0% {
    background-color: #e4e8e8;
  }

  25% {
    background-color: #d4d5d5;
  }

  50% {
    background-color: #c5c8c8;
  }

  75% {
    background-color: #d4d5d5;
  }

  100% {
    background-color: #e4e8e8;
  }
}

/* 0%		{ background-color: #0dadad;}
		25%		{ background-color: #119e9e;}
		50%		{ background-color: #0b7979;}
		75%		{ background-color: #119e9e;}
		100%  { background-color: #0dadad;} */
.blink_text {
  color: #000;
  font-weight: bold;
  font-size: 2rem;
  animation: blinkingText 2s infinite;
}

@keyframes blinkingText {
  0% {
    color: #10c018;
  }

  25% {
    color: #1056c0;
  }

  50% {
    color: #ef0a1a;
  }

  75% {
    color: #254878;
  }

  100% {
    color: #04a1d5;
  }
}

.row_success {
  background-color: #80ec85;
  text-align: center;
  color: rgb(32, 32, 32);
}

.row_error {
  background-color: #f59386;
  text-align: center;
  color: rgb(32, 32, 32);
}

.column {
  height: fit-content;
  font-size: 12px !important;
}

/* .left {
  width: 35px;
  padding: 2px;
} */

.right {
  width: 200px;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}


.v-icon.notranslate.ml-0.pl-0.mr-0.pr-0.font_small.v-icon--link.material-icons.theme--light {
  font-size: 24px !important;
}

/*   
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 12px!important;
   
    width: 100px !important;
  
}


.v-data-table>.v-data-table__wrapper>table>tbody>tr>td, .v-data-table>.v-data-table__wrapper>table>tbody>tr>th, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>td, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>th, .v-data-table>.v-data-table__wrapper>table>thead>tr>td, .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    padding: 0 !important ;
    padding-top: 0px !important ;
    padding-right: 0 !important ;
    padding-bottom: 0px !important ;
    padding-left: 0 !important ; 
    -webkit-transition: height .2s cubic-bezier(.4,0,.6,1);
    transition: height .2s cubic-bezier(.4,0,.6,1);
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td, .v-data-table>.v-data-table__wrapper>table>tbody>tr>th, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>td, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>th, .v-data-table>.v-data-table__wrapper>table>thead>tr>td, .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    padding: 0 0px !important ;
    padding-top: 0px !important ;
    padding-right: 0px !important ;
    padding-bottom: 0px!important ;
    padding-left: 0px !important ;
    -webkit-transition: height .2s cubic-bezier(.4,0,.6,1);
    transition: height .2s cubic-bezier(.4,0,.6,1);
}


.v-data-table>.v-data-table__wrapper>table>tbody>tr>td, .v-data-table>.v-data-table__wrapper>table>tbody>tr>th, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>td, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>th, .v-data-table>.v-data-table__wrapper>table>thead>tr>td, .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    padding: 0 0 0 0 !important; 
    -webkit-transition: height .2s cubic-bezier(.4,0,.6,1);
    transition: height .2s cubic-bezier(.4,0,.6,1);
} */

.v-application .body-2 {
  font-size: small !important;
  letter-spacing: .0178571429em !important;
  line-height: 1.25rem;
}

.print-error-message[data-v-bbb6eae2] {
  border: 1px solid red;
  margin-top: 15px;
  padding: 10px;
  font-weight: 500;
  background: #fef8f8;
  text-align: center;
}

.containerMaxWidth {
  max-width: max-content !important;
  width: 100% !important;
}

.font-sizeSmaller{
  font-size: x-small !important;
}

/* 

.v-table>.v-table__wrapper>table {
    border-spacing: 0;
    width: max-content !important;
    font-weight: 400 !important;
    font-size: 13px !important;
}
.v-table>table>thead>tr>td, .v-table>.v-table__wrapper>table>thead>tr>th {
  padding-left: 2px !important;
    padding-right: 2px !important;
   
}
table.v-table tbody td {
    font-weight: 400 !important;
    font-size: 13px !important;
} */

.v-data-table { 
  overflow-x: auto !important;
}

/* .v-table__overflow {
    width: 150%;
    overflow-x: auto;
    overflow-y: hidden;
} */


.custom-v-data-table .v-table__wrapper {
  overflow-x: auto; /* Enable horizontal scrolling */
}

.failed-width  .v-table__wrapper > table {
    width: 100% !important; /* Adjust width as needed */
    border-spacing: 0;
}
.Quote-width  .v-table__wrapper > table {
    width: 125% !important; /* Adjust width as needed */
    border-spacing: 0;
}


.default-width   .v-table__wrapper > table {
    width: 100% !important; /* Adjust width as needed */
    border-spacing: 0;
}


</style>

